"use strict";
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractErrorSignatures = exports.ContractErrorNames = exports.ContractErrorsBySignature = exports.ContractErrorsByName = void 0;
exports.ContractErrorsByName = {
    AccessControl_Sender_Must_Be_Admin: {
        contractName: 'FoundationTreasury',
        name: 'AccessControl_Sender_Must_Be_Admin',
        errorCode: '0xc41405ee',
    },
    AccessControlBadConfirmation: {
        contractName: 'NFTDropCollection',
        name: 'AccessControlBadConfirmation',
        errorCode: '0x6697b232',
    },
    AccessControlUnauthorizedAccount: {
        contractName: 'NFTDropCollection',
        name: 'AccessControlUnauthorizedAccount',
        errorCode: '0xe2517d3f',
        params: [
            { name: 'account', type: 'address' },
            { name: 'neededRole', type: 'bytes32' },
        ],
    },
    AddressEmptyCode: {
        contractName: 'MultiTokenCollection',
        name: 'AddressEmptyCode',
        errorCode: '0x9996b315',
        params: [{ name: 'target', type: 'address' }],
    },
    AddressInsufficientBalance: {
        contractName: 'MultiTokenCollection',
        name: 'AddressInsufficientBalance',
        errorCode: '0xcd786059',
        params: [{ name: 'account', type: 'address' }],
    },
    AddressLibrary_Proxy_Call_Did_Not_Return_A_Contract: {
        contractName: 'NFTCollectionFactory',
        name: 'AddressLibrary_Proxy_Call_Did_Not_Return_A_Contract',
        errorCode: '0x8556197e',
        params: [{ name: 'addressReturned', type: 'address' }],
    },
    AdminRole_Caller_Does_Not_Have_Admin_Role: {
        contractName: 'NFTDropCollection',
        name: 'AdminRole_Caller_Does_Not_Have_Admin_Role',
        errorCode: '0xf6899cee',
    },
    AdminRoleEnumerable_Caller_Does_Not_Have_Admin_Role: {
        contractName: 'FoundationTreasury',
        name: 'AdminRoleEnumerable_Caller_Does_Not_Have_Admin_Role',
        errorCode: '0x25662033',
    },
    CollateralManagement_Cannot_Withdraw_To_Address_Zero: {
        contractName: 'FoundationTreasury',
        name: 'CollateralManagement_Cannot_Withdraw_To_Address_Zero',
        errorCode: '0x0b335924',
    },
    CollateralManagement_Cannot_Withdraw_To_Self: {
        contractName: 'FoundationTreasury',
        name: 'CollateralManagement_Cannot_Withdraw_To_Self',
        errorCode: '0xf72e1989',
    },
    CollectionTokenRoyalties_Address_Already_Set: {
        contractName: 'MultiTokenCollection',
        name: 'CollectionTokenRoyalties_Address_Already_Set',
        errorCode: '0xcde01bec',
    },
    CollectionTokenRoyalties_Payment_Address_Required: {
        contractName: 'MultiTokenCollection',
        name: 'CollectionTokenRoyalties_Payment_Address_Required',
        errorCode: '0xd744918b',
    },
    DelegateForwarder_For_Internal_Use_Only: {
        contractName: 'Worlds',
        name: 'DelegateForwarder_For_Internal_Use_Only',
        errorCode: '0xeab5a03f',
    },
    DropMarketLibrary_General_Availability_Start_Time_Has_Expired: {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_General_Availability_Start_Time_Has_Expired',
        errorCode: '0xfc52dce0',
    },
    DropMarketLibrary_Mint_Permission_Required: {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_Mint_Permission_Required',
        errorCode: '0x0de5a71e',
    },
    DropMarketLibrary_Only_Callable_By_Collection_Admin: {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_Only_Callable_By_Collection_Admin',
        errorCode: '0x99181b9b',
    },
    DropMarketLibrary_Time_Too_Far_In_The_Future: {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_Time_Too_Far_In_The_Future',
        errorCode: '0x77e1d3c7',
        params: [{ name: 'maxTime', type: 'uint256' }],
    },
    ECDSAInvalidSignature: {
        contractName: 'Worlds',
        name: 'ECDSAInvalidSignature',
        errorCode: '0xf645eedf',
    },
    ECDSAInvalidSignatureLength: {
        contractName: 'Worlds',
        name: 'ECDSAInvalidSignatureLength',
        errorCode: '0xfce698f7',
        params: [{ name: 'length', type: 'uint256' }],
    },
    ECDSAInvalidSignatureS: {
        contractName: 'Worlds',
        name: 'ECDSAInvalidSignatureS',
        errorCode: '0xd78bce0c',
        params: [{ name: 's', type: 'bytes32' }],
    },
    EIP712_Invalid_Signer: {
        contractName: 'Worlds',
        name: 'EIP712_Invalid_Signer',
        errorCode: '0x3d20eda8',
    },
    ERC1155InsufficientBalance: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InsufficientBalance',
        errorCode: '0x03dee4c5',
        params: [
            { name: 'sender', type: 'address' },
            { name: 'balance', type: 'uint256' },
            { name: 'needed', type: 'uint256' },
            { name: 'tokenId', type: 'uint256' },
        ],
    },
    ERC1155InvalidApprover: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidApprover',
        errorCode: '0x3e31884e',
        params: [{ name: 'approver', type: 'address' }],
    },
    ERC1155InvalidArrayLength: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidArrayLength',
        errorCode: '0x5b059991',
        params: [
            { name: 'idsLength', type: 'uint256' },
            { name: 'valuesLength', type: 'uint256' },
        ],
    },
    ERC1155InvalidOperator: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidOperator',
        errorCode: '0xced3e100',
        params: [{ name: 'operator', type: 'address' }],
    },
    ERC1155InvalidReceiver: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidReceiver',
        errorCode: '0x57f447ce',
        params: [{ name: 'receiver', type: 'address' }],
    },
    ERC1155InvalidSender: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidSender',
        errorCode: '0x01a83514',
        params: [{ name: 'sender', type: 'address' }],
    },
    ERC1155MissingApprovalForAll: {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155MissingApprovalForAll',
        errorCode: '0xe237d922',
        params: [
            { name: 'operator', type: 'address' },
            { name: 'owner', type: 'address' },
        ],
    },
    ERC1167FailedCreateClone: {
        contractName: 'NFTCollectionFactory',
        name: 'ERC1167FailedCreateClone',
        errorCode: '0xc2f868f4',
    },
    ERC721IncorrectOwner: {
        contractName: 'NFTCollection',
        name: 'ERC721IncorrectOwner',
        errorCode: '0x64283d7b',
        params: [
            { name: 'sender', type: 'address' },
            { name: 'tokenId', type: 'uint256' },
            { name: 'owner', type: 'address' },
        ],
    },
    ERC721InsufficientApproval: {
        contractName: 'NFTCollection',
        name: 'ERC721InsufficientApproval',
        errorCode: '0x177e802f',
        params: [
            { name: 'operator', type: 'address' },
            { name: 'tokenId', type: 'uint256' },
        ],
    },
    ERC721InvalidApprover: {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidApprover',
        errorCode: '0xa9fbf51f',
        params: [{ name: 'approver', type: 'address' }],
    },
    ERC721InvalidOperator: {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidOperator',
        errorCode: '0x5b08ba18',
        params: [{ name: 'operator', type: 'address' }],
    },
    ERC721InvalidOwner: {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidOwner',
        errorCode: '0x89c62b64',
        params: [{ name: 'owner', type: 'address' }],
    },
    ERC721InvalidReceiver: {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidReceiver',
        errorCode: '0x64a0ae92',
        params: [{ name: 'receiver', type: 'address' }],
    },
    ERC721InvalidSender: {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidSender',
        errorCode: '0x73c6ac6e',
        params: [{ name: 'sender', type: 'address' }],
    },
    ERC721NonexistentToken: {
        contractName: 'NFTCollection',
        name: 'ERC721NonexistentToken',
        errorCode: '0x7e273289',
        params: [{ name: 'tokenId', type: 'uint256' }],
    },
    ERC721UserRoles_User_Has_No_Roles: {
        contractName: 'Worlds',
        name: 'ERC721UserRoles_User_Has_No_Roles',
        errorCode: '0x74f85194',
    },
    ERC721UserRoles_User_Must_Not_Be_Zero_Address: {
        contractName: 'Worlds',
        name: 'ERC721UserRoles_User_Must_Not_Be_Zero_Address',
        errorCode: '0xecdd1e72',
    },
    ERC721UserRoles_User_Role_Already_Set: {
        contractName: 'Worlds',
        name: 'ERC721UserRoles_User_Role_Already_Set',
        errorCode: '0xbdf15e90',
    },
    FailedInnerCall: {
        contractName: 'MultiTokenCollection',
        name: 'FailedInnerCall',
        errorCode: '0x1425ea42',
    },
    FETH_Cannot_Deposit_For_Lockup_With_Address_Zero: {
        contractName: 'FETH',
        name: 'FETH_Cannot_Deposit_For_Lockup_With_Address_Zero',
        errorCode: '0xda7f52ef',
    },
    FETH_Cannot_Deposit_To_Address_Zero: {
        contractName: 'FETH',
        name: 'FETH_Cannot_Deposit_To_Address_Zero',
        errorCode: '0x9681468e',
    },
    FETH_Cannot_Deposit_To_FETH: {
        contractName: 'FETH',
        name: 'FETH_Cannot_Deposit_To_FETH',
        errorCode: '0xcce444a3',
    },
    FETH_Cannot_Withdraw_To_Address_Zero: {
        contractName: 'FETH',
        name: 'FETH_Cannot_Withdraw_To_Address_Zero',
        errorCode: '0x586e5c79',
    },
    FETH_Cannot_Withdraw_To_FETH: {
        contractName: 'FETH',
        name: 'FETH_Cannot_Withdraw_To_FETH',
        errorCode: '0x82b3dce9',
    },
    FETH_Cannot_Withdraw_To_Market: {
        contractName: 'FETH',
        name: 'FETH_Cannot_Withdraw_To_Market',
        errorCode: '0xe296545e',
    },
    FETH_Escrow_Expired: {
        contractName: 'FETH',
        name: 'FETH_Escrow_Expired',
        errorCode: '0x95600b3d',
    },
    FETH_Escrow_Not_Found: {
        contractName: 'FETH',
        name: 'FETH_Escrow_Not_Found',
        errorCode: '0x2d3aa470',
    },
    FETH_Expiration_Too_Far_In_Future: {
        contractName: 'FETH',
        name: 'FETH_Expiration_Too_Far_In_Future',
        errorCode: '0x01437d88',
    },
    FETH_Insufficient_Allowance: {
        contractName: 'FETH',
        name: 'FETH_Insufficient_Allowance',
        errorCode: '0xfc87283a',
        params: [{ name: 'amount', type: 'uint256' }],
    },
    FETH_Insufficient_Available_Funds: {
        contractName: 'FETH',
        name: 'FETH_Insufficient_Available_Funds',
        errorCode: '0xa8834ff0',
        params: [{ name: 'amount', type: 'uint256' }],
    },
    FETH_Insufficient_Escrow: {
        contractName: 'FETH',
        name: 'FETH_Insufficient_Escrow',
        errorCode: '0x4531598a',
        params: [{ name: 'amount', type: 'uint256' }],
    },
    FETH_Invalid_Lockup_Duration: {
        contractName: 'FETH',
        name: 'FETH_Invalid_Lockup_Duration',
        errorCode: '0xbe4bdada',
    },
    FETH_Market_Must_Be_A_Contract: {
        contractName: 'FETH',
        name: 'FETH_Market_Must_Be_A_Contract',
        errorCode: '0x1d46bfdc',
    },
    FETH_Must_Deposit_Non_Zero_Amount: {
        contractName: 'FETH',
        name: 'FETH_Must_Deposit_Non_Zero_Amount',
        errorCode: '0xd5e2ea2a',
    },
    FETH_Must_Lockup_Non_Zero_Amount: {
        contractName: 'FETH',
        name: 'FETH_Must_Lockup_Non_Zero_Amount',
        errorCode: '0x8b7a046f',
    },
    FETH_No_Funds_To_Withdraw: {
        contractName: 'FETH',
        name: 'FETH_No_Funds_To_Withdraw',
        errorCode: '0xb64cff25',
    },
    FETH_Only_FND_Market_Allowed: {
        contractName: 'FETH',
        name: 'FETH_Only_FND_Market_Allowed',
        errorCode: '0xce3c4d0e',
    },
    FETH_Too_Much_ETH_Provided: {
        contractName: 'FETH',
        name: 'FETH_Too_Much_ETH_Provided',
        errorCode: '0x995ace53',
    },
    FETH_Transfer_To_Address_Zero_Not_Allowed: {
        contractName: 'FETH',
        name: 'FETH_Transfer_To_Address_Zero_Not_Allowed',
        errorCode: '0x3450e8b1',
    },
    FETH_Transfer_To_FETH_Not_Allowed: {
        contractName: 'FETH',
        name: 'FETH_Transfer_To_FETH_Not_Allowed',
        errorCode: '0xb7c2c08f',
    },
    FETHNode_FETH_Address_Is_Not_A_Contract: {
        contractName: 'NFTDropMarket',
        name: 'FETHNode_FETH_Address_Is_Not_A_Contract',
        errorCode: '0xde580827',
    },
    FETHNode_Only_FETH_Can_Transfer_ETH: {
        contractName: 'NFTDropMarket',
        name: 'FETHNode_Only_FETH_Can_Transfer_ETH',
        errorCode: '0xaa39384e',
    },
    FethNode_Too_Much_Value_Provided: {
        contractName: 'NFTDropMarket',
        name: 'FethNode_Too_Much_Value_Provided',
        errorCode: '0xabf2f33b',
        params: [{ name: 'expectedValueAmount', type: 'uint256' }],
    },
    FNDMiddleware_NFTs_And_TokenIds_Must_Be_The_Same_Length: {
        contractName: 'FNDMiddleware',
        name: 'FNDMiddleware_NFTs_And_TokenIds_Must_Be_The_Same_Length',
        errorCode: '0x5deff89b',
    },
    FoundationTreasuryNode_Address_Is_Not_A_Contract: {
        contractName: 'NFTDropMarket',
        name: 'FoundationTreasuryNode_Address_Is_Not_A_Contract',
        errorCode: '0xa2ee8940',
    },
    FoundationTreasuryNode_Caller_Not_Admin: {
        contractName: 'NFTDropMarket',
        name: 'FoundationTreasuryNode_Caller_Not_Admin',
        errorCode: '0xaf8db333',
    },
    FoundationTreasuryNode_Caller_Not_Operator: {
        contractName: 'NFTDropMarket',
        name: 'FoundationTreasuryNode_Caller_Not_Operator',
        errorCode: '0x795337bf',
    },
    InvalidInitialization: {
        contractName: 'NFTCollection',
        name: 'InvalidInitialization',
        errorCode: '0xf92ee8a9',
    },
    InvalidShortString: {
        contractName: 'NFTCollection',
        name: 'InvalidShortString',
        errorCode: '0xb3512b0c',
    },
    LazyMintedCollection_Mint_Count_Must_Be_Greater_Than_Zero: {
        contractName: 'NFTDropCollection',
        name: 'LazyMintedCollection_Mint_Count_Must_Be_Greater_Than_Zero',
        errorCode: '0xce15a284',
    },
    MarketUtils_Feth_Is_Not_A_Contract: {
        contractName: 'MarketUtils',
        name: 'MarketUtils_Feth_Is_Not_A_Contract',
        errorCode: '0x8e9cd242',
    },
    MarketUtils_Royalty_Registry_Is_Not_A_Contract: {
        contractName: 'MarketUtils',
        name: 'MarketUtils_Royalty_Registry_Is_Not_A_Contract',
        errorCode: '0xb9c39222',
    },
    MinterRole_Caller_Does_Not_Have_Minter_Or_Admin_Role: {
        contractName: 'NFTDropCollection',
        name: 'MinterRole_Caller_Does_Not_Have_Minter_Or_Admin_Role',
        errorCode: '0x15301d40',
    },
    MultiTokenCollection_Contract_URI_Required: {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenCollection_Contract_URI_Required',
        errorCode: '0x72434cd9',
    },
    MultiTokenCollection_Token_Already_Exists: {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenCollection_Token_Already_Exists',
        errorCode: '0x0edd7caf',
    },
    MultiTokenDropMarketFixedPriceSale_Collection_Must_Be_ERC_1155: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Collection_Must_Be_ERC_1155',
        errorCode: '0x49bedeb9',
    },
    MultiTokenDropMarketFixedPriceSale_General_Access_Not_Open: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_General_Access_Not_Open',
        errorCode: '0x928a5e07',
        params: [{ name: 'generalAvailabilityStartTime', type: 'uint256' }],
    },
    MultiTokenDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
        errorCode: '0xd7028da0',
    },
    MultiTokenDropMarketFixedPriceSale_Must_Have_Available_Supply: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Must_Have_Available_Supply',
        errorCode: '0xfbbeeb76',
    },
    MultiTokenDropMarketFixedPriceSale_Payment_Address_Required: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Payment_Address_Required',
        errorCode: '0x0991f71f',
    },
    MultiTokenDropMarketFixedPriceSale_Recipient_Cannot_Be_Zero_Address: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Recipient_Cannot_Be_Zero_Address',
        errorCode: '0x285a366d',
    },
    MultiTokenDropMarketFixedPriceSale_Sale_Terms_Not_Found: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Sale_Terms_Not_Found',
        errorCode: '0x11378a56',
    },
    MultiTokenDropMarketFixedPriceSale_Start_Time_Is_After_Mint_End_Time: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Start_Time_Is_After_Mint_End_Time',
        errorCode: '0xeab1694c',
        params: [{ name: 'mintEndTime', type: 'uint256' }],
    },
    MultiTokenDropMarketFixedPriceSale_Token_Already_Listed_For_Sale: {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Token_Already_Listed_For_Sale',
        errorCode: '0x7bec12a0',
        params: [{ name: 'existingSaleTermsId', type: 'uint256' }],
    },
    MultiTokenDropMarketFixedPriceSale_Too_Much_Value_Provided: {
        contractName: 'NFTMarketRouter',
        name: 'MultiTokenDropMarketFixedPriceSale_Too_Much_Value_Provided',
        errorCode: '0x084cdac4',
        params: [{ name: 'valueRemaining', type: 'uint256' }],
    },
    MultiTokenDropMarketNode_Market_Is_Not_A_Contract: {
        contractName: 'NFTMarketRouter',
        name: 'MultiTokenDropMarketNode_Market_Is_Not_A_Contract',
        errorCode: '0xcc2d9758',
    },
    MultiTokenMintSchedule_Mint_Time_Has_Already_Expired: {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenMintSchedule_Mint_Time_Has_Already_Expired',
        errorCode: '0x6144a0ae',
    },
    MultiTokenMintSchedule_Token_Minting_Has_Ended: {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenMintSchedule_Token_Minting_Has_Ended',
        errorCode: '0x6b4238d8',
    },
    MultiTokenMintSchedule_Token_Not_Found: {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenMintSchedule_Token_Not_Found',
        errorCode: '0xe56b0817',
    },
    NFTCollection_Max_Token_Id_Has_Already_Been_Minted: {
        contractName: 'NFTCollection',
        name: 'NFTCollection_Max_Token_Id_Has_Already_Been_Minted',
        errorCode: '0x797049f0',
        params: [{ name: 'maxTokenId', type: 'uint256' }],
    },
    NFTCollection_Token_CID_Already_Minted: {
        contractName: 'NFTCollection',
        name: 'NFTCollection_Token_CID_Already_Minted',
        errorCode: '0xcd47065e',
    },
    NFTCollection_Token_Creator_Payment_Address_Required: {
        contractName: 'NFTCollection',
        name: 'NFTCollection_Token_Creator_Payment_Address_Required',
        errorCode: '0x49860fb5',
    },
    NFTCollectionFactoryCollectionTypes_Collection_Type_Is_Null: {
        contractName: 'NFTCollectionFactory',
        name: 'NFTCollectionFactoryCollectionTypes_Collection_Type_Is_Null',
        errorCode: '0x34a6f550',
    },
    NFTCollectionFactoryNode_Address_Is_Not_A_Contract: {
        contractName: 'NFTMarketRouter',
        name: 'NFTCollectionFactoryNode_Address_Is_Not_A_Contract',
        errorCode: '0x7fa34330',
    },
    NFTCollectionFactorySharedTemplates_Implementation_Not_A_Contract: {
        contractName: 'NFTCollectionFactory',
        name: 'NFTCollectionFactorySharedTemplates_Implementation_Not_A_Contract',
        errorCode: '0x1c22bef2',
    },
    NFTCollectionFactorySharedTemplates_Invalid_Collection_Type: {
        contractName: 'NFTCollectionFactory',
        name: 'NFTCollectionFactorySharedTemplates_Invalid_Collection_Type',
        errorCode: '0xd8e61d1c',
    },
    NFTCreateAndListTimedEditionCollection_Sale_Duration_Cannot_Be_Zero: {
        contractName: 'NFTMarketRouter',
        name: 'NFTCreateAndListTimedEditionCollection_Sale_Duration_Cannot_Be_Zero',
        errorCode: '0xa87860d1',
    },
    NFTDropCollection_Exceeds_Max_Token_Id: {
        contractName: 'NFTDropCollection',
        name: 'NFTDropCollection_Exceeds_Max_Token_Id',
        errorCode: '0xab4e7f1f',
        params: [{ name: 'maxTokenId', type: 'uint256' }],
    },
    NFTDropMarket_NFT_Already_Minted: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarket_NFT_Already_Minted',
        errorCode: '0x5ca60e0d',
    },
    NFTDropMarketCore_Collection_Already_Listed_For_Sale: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Collection_Already_Listed_For_Sale',
        errorCode: '0x25402930',
    },
    NFTDropMarketCore_Invalid_Merkle_Root: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Invalid_Merkle_Root',
        errorCode: '0x229955da',
    },
    NFTDropMarketCore_Must_Have_Available_Supply: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Must_Have_Available_Supply',
        errorCode: '0x3c263ade',
    },
    NFTDropMarketCore_Must_Support_Collection_Mint_Interface: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Must_Support_Collection_Mint_Interface',
        errorCode: '0x17fdef07',
    },
    NFTDropMarketCore_Must_Support_ERC721: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Must_Support_ERC721',
        errorCode: '0x29d190d2',
    },
    NFTDropMarketDutchAuction_Auction_Has_Not_Started_Yet: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Auction_Has_Not_Started_Yet',
        errorCode: '0x70fdd722',
        params: [{ name: 'startTime', type: 'uint256' }],
    },
    NFTDropMarketDutchAuction_Auction_Not_Found: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Auction_Not_Found',
        errorCode: '0xcc4f974c',
    },
    NFTDropMarketDutchAuction_Clearing_Price_Not_Reached: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Clearing_Price_Not_Reached',
        errorCode: '0x1dd4212a',
        params: [
            { name: 'endTime', type: 'uint256' },
            { name: 'numberStillAvailable', type: 'uint256' },
        ],
    },
    NFTDropMarketDutchAuction_Creator_Revenue_Has_Already_Been_Withdrawn: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Creator_Revenue_Has_Already_Been_Withdrawn',
        errorCode: '0xba5a58b2',
    },
    NFTDropMarketDutchAuction_End_Time_Too_Far_In_The_Future: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_End_Time_Too_Far_In_The_Future',
        errorCode: '0x82fae596',
        params: [{ name: 'maxTime', type: 'uint256' }],
    },
    NFTDropMarketDutchAuction_Invalid_Nft_Recipient: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Invalid_Nft_Recipient',
        errorCode: '0xae36b525',
    },
    NFTDropMarketDutchAuction_Limit_Per_Account_Must_Be_Set: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Limit_Per_Account_Must_Be_Set',
        errorCode: '0x92865bfe',
    },
    NFTDropMarketDutchAuction_Min_Price_Must_Be_Less_Than_Max_Price: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Min_Price_Must_Be_Less_Than_Max_Price',
        errorCode: '0x5a42b079',
    },
    NFTDropMarketDutchAuction_Mint_Count_Must_Be_Greater_Than_Zero: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Mint_Count_Must_Be_Greater_Than_Zero',
        errorCode: '0xb3896a51',
    },
    NFTDropMarketDutchAuction_Mint_Exceeds_Limit_Per_Account: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Mint_Exceeds_Limit_Per_Account',
        errorCode: '0xb3c84a0b',
        params: [
            { name: 'currentMintCount', type: 'uint256' },
            { name: 'limitPerAccount', type: 'uint256' },
        ],
    },
    NFTDropMarketDutchAuction_Must_Have_Available_Supply: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Must_Have_Available_Supply',
        errorCode: '0x61b9c86b',
    },
    NFTDropMarketDutchAuction_Nothing_To_Rebate_At_This_Time: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Nothing_To_Rebate_At_This_Time',
        errorCode: '0x433b2e95',
    },
    NFTDropMarketDutchAuction_Sale_Duration_Must_Be_Greater_Than_Zero: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Sale_Duration_Must_Be_Greater_Than_Zero',
        errorCode: '0x3335f9a9',
    },
    NFTDropMarketDutchAuction_Start_Time_Must_Not_Be_In_The_Past: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Start_Time_Must_Not_Be_In_The_Past',
        errorCode: '0x3a3baeca',
    },
    NFTDropMarketFixedPriceSale_Cannot_Buy_More_Than_Limit: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Cannot_Buy_More_Than_Limit',
        errorCode: '0xfa7c028e',
        params: [{ name: 'limitPerAccount', type: 'uint256' }],
    },
    NFTDropMarketFixedPriceSale_Early_Access_Not_Open: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Early_Access_Not_Open',
        errorCode: '0x8ba20e68',
        params: [{ name: 'earlyAccessStartTime', type: 'uint256' }],
    },
    NFTDropMarketFixedPriceSale_Early_Access_Start_Time_Has_Expired: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Early_Access_Start_Time_Has_Expired',
        errorCode: '0xdddbb7cd',
    },
    NFTDropMarketFixedPriceSale_General_Access_Is_Open: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_General_Access_Is_Open',
        errorCode: '0xf2279aef',
    },
    NFTDropMarketFixedPriceSale_General_Access_Not_Open: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_General_Access_Not_Open',
        errorCode: '0x26763e5a',
        params: [{ name: 'generalAvailabilityStartTime', type: 'uint256' }],
    },
    NFTDropMarketFixedPriceSale_Invalid_Merkle_Proof: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Invalid_Merkle_Proof',
        errorCode: '0xf88937c8',
    },
    NFTDropMarketFixedPriceSale_Limit_Per_Account_Must_Be_Set: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Limit_Per_Account_Must_Be_Set',
        errorCode: '0x250099ab',
    },
    NFTDropMarketFixedPriceSale_Must_Be_Listed_For_Sale: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Must_Be_Listed_For_Sale',
        errorCode: '0x974bcaec',
    },
    NFTDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
        errorCode: '0x2d69aaf4',
    },
    NFTDropMarketFixedPriceSale_Must_Have_Non_Zero_Early_Access_Duration: {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Must_Have_Non_Zero_Early_Access_Duration',
        errorCode: '0x77b2af4b',
    },
    NFTDropMarketNode_Address_Is_Not_A_Contract: {
        contractName: 'NFTMarketRouter',
        name: 'NFTDropMarketNode_Address_Is_Not_A_Contract',
        errorCode: '0xeda2199a',
    },
    NFTLimitedEditionCollection_Exceeds_Max_Token_Id: {
        contractName: 'NFTLimitedEditionCollection',
        name: 'NFTLimitedEditionCollection_Exceeds_Max_Token_Id',
        errorCode: '0x718fae19',
        params: [{ name: 'maxTokenId', type: 'uint256' }],
    },
    NFTMarketAuction_Already_Initialized: {
        contractName: 'NFTMarket',
        name: 'NFTMarketAuction_Already_Initialized',
        errorCode: '0xeb2e06c0',
    },
    NFTMarketBuyPrice_Cannot_Buy_At_Lower_Price: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Cannot_Buy_At_Lower_Price',
        errorCode: '0x16b5016f',
        params: [{ name: 'buyPrice', type: 'uint256' }],
    },
    NFTMarketBuyPrice_Cannot_Buy_Unset_Price: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Cannot_Buy_Unset_Price',
        errorCode: '0xda48e184',
    },
    NFTMarketBuyPrice_Cannot_Cancel_Unset_Price: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Cannot_Cancel_Unset_Price',
        errorCode: '0xc09f8e82',
    },
    NFTMarketBuyPrice_Only_Owner_Can_Cancel_Price: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Only_Owner_Can_Cancel_Price',
        errorCode: '0xf049b41a',
        params: [{ name: 'owner', type: 'address' }],
    },
    NFTMarketBuyPrice_Only_Owner_Can_Set_Price: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Only_Owner_Can_Set_Price',
        errorCode: '0x697d918e',
        params: [{ name: 'owner', type: 'address' }],
    },
    NFTMarketBuyPrice_Only_Owner_Can_Update_Nft: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Only_Owner_Can_Update_Nft',
        errorCode: '0xc89fba3b',
        params: [{ name: 'owner', type: 'address' }],
    },
    NFTMarketBuyPrice_Price_Already_Set: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Price_Already_Set',
        errorCode: '0xb6950f36',
    },
    NFTMarketBuyPrice_Price_Too_High: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Price_Too_High',
        errorCode: '0x35ec82cb',
    },
    NFTMarketBuyPrice_Seller_Mismatch: {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Seller_Mismatch',
        errorCode: '0x32f3b033',
        params: [{ name: 'seller', type: 'address' }],
    },
    NFTMarketCore_Can_Not_Update_Unlisted_Nft: {
        contractName: 'NFTMarket',
        name: 'NFTMarketCore_Can_Not_Update_Unlisted_Nft',
        errorCode: '0xe390a4ec',
    },
    NFTMarketCore_Seller_Not_Found: {
        contractName: 'NFTMarket',
        name: 'NFTMarketCore_Seller_Not_Found',
        errorCode: '0x57a016b3',
    },
    NFTMarketFees_Invalid_Protocol_Fee: {
        contractName: 'NFTDropMarket',
        name: 'NFTMarketFees_Invalid_Protocol_Fee',
        errorCode: '0x567777b0',
    },
    NFTMarketFees_Market_Utils_Is_Not_A_Contract: {
        contractName: 'NFTDropMarket',
        name: 'NFTMarketFees_Market_Utils_Is_Not_A_Contract',
        errorCode: '0x5034dfac',
    },
    NFTMarketNode_Address_Is_Not_A_Contract: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketNode_Address_Is_Not_A_Contract',
        errorCode: '0x48dc361f',
    },
    NFTMarketOffer_Cannot_Be_Made_While_In_Auction: {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Cannot_Be_Made_While_In_Auction',
        errorCode: '0x83a483f5',
    },
    NFTMarketOffer_Offer_Below_Min_Amount: {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_Below_Min_Amount',
        errorCode: '0x24237361',
        params: [{ name: 'currentOfferAmount', type: 'uint256' }],
    },
    NFTMarketOffer_Offer_Expired: {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_Expired',
        errorCode: '0x8c9e57cf',
        params: [{ name: 'expiry', type: 'uint256' }],
    },
    NFTMarketOffer_Offer_From_Does_Not_Match: {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_From_Does_Not_Match',
        errorCode: '0xa7d95dc3',
        params: [{ name: 'currentOfferFrom', type: 'address' }],
    },
    NFTMarketOffer_Offer_Must_Be_At_Least_Min_Amount: {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_Must_Be_At_Least_Min_Amount',
        errorCode: '0xe40a30e6',
        params: [{ name: 'minOfferAmount', type: 'uint256' }],
    },
    NFTMarketReserveAuction_Already_Listed: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Already_Listed',
        errorCode: '0x7618a003',
        params: [{ name: 'auctionId', type: 'uint256' }],
    },
    NFTMarketReserveAuction_Bid_Must_Be_At_Least_Min_Amount: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Bid_Must_Be_At_Least_Min_Amount',
        errorCode: '0xcd698a19',
        params: [{ name: 'minAmount', type: 'uint256' }],
    },
    NFTMarketReserveAuction_Cannot_Bid_Lower_Than_Reserve_Price: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Bid_Lower_Than_Reserve_Price',
        errorCode: '0x31e6f71c',
        params: [{ name: 'reservePrice', type: 'uint256' }],
    },
    NFTMarketReserveAuction_Cannot_Bid_On_Ended_Auction: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Bid_On_Ended_Auction',
        errorCode: '0x3feeb88d',
        params: [{ name: 'endTime', type: 'uint256' }],
    },
    NFTMarketReserveAuction_Cannot_Bid_On_Nonexistent_Auction: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Bid_On_Nonexistent_Auction',
        errorCode: '0x125197d1',
    },
    NFTMarketReserveAuction_Cannot_Finalize_Already_Settled_Auction: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Finalize_Already_Settled_Auction',
        errorCode: '0x4b6ad8fa',
    },
    NFTMarketReserveAuction_Cannot_Finalize_Auction_In_Progress: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Finalize_Auction_In_Progress',
        errorCode: '0x3a017f60',
        params: [{ name: 'endTime', type: 'uint256' }],
    },
    NFTMarketReserveAuction_Cannot_Rebid_Over_Outstanding_Bid: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Rebid_Over_Outstanding_Bid',
        errorCode: '0xe1405768',
    },
    NFTMarketReserveAuction_Cannot_Update_Auction_In_Progress: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Update_Auction_In_Progress',
        errorCode: '0x5aea7c47',
    },
    NFTMarketReserveAuction_Cannot_Update_Nft_While_Auction_In_Progress: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Update_Nft_While_Auction_In_Progress',
        errorCode: '0xa2a745e9',
    },
    NFTMarketReserveAuction_Not_Matching_Seller: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Not_Matching_Seller',
        errorCode: '0xe64526ee',
        params: [{ name: 'seller', type: 'address' }],
    },
    NFTMarketReserveAuction_Price_Already_Set: {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Price_Already_Set',
        errorCode: '0x4b669ac7',
    },
    NFTMarketRouterList_Buy_Price_Set_But_Should_Set_Buy_Price_Is_False: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Buy_Price_Set_But_Should_Set_Buy_Price_Is_False',
        errorCode: '0x1a8a2c10',
    },
    NFTMarketRouterList_Duration_Set_Without_Reserve_Price: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Duration_Set_Without_Reserve_Price',
        errorCode: '0xbf2c1df0',
    },
    NFTMarketRouterList_Missing_World_Associations: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Missing_World_Associations',
        errorCode: '0xbee0394e',
    },
    NFTMarketRouterList_Must_Set_Reserve_Buy_Price_Or_World: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Must_Set_Reserve_Buy_Price_Or_World',
        errorCode: '0x3c574a98',
    },
    NFTMarketRouterList_Must_Set_Reserve_Or_Buy_Price: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Must_Set_Reserve_Or_Buy_Price',
        errorCode: '0x75ce98b6',
    },
    NFTMarketRouterList_Schedule_Set_Without_Prices: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Schedule_Set_Without_Prices',
        errorCode: '0x69a1d316',
    },
    NFTMarketRouterList_Token_Ids_Not_Set: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Token_Ids_Not_Set',
        errorCode: '0xa9d004a5',
    },
    NFTMarketRouterList_World_Id_Set_Without_Prices: {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_World_Id_Set_Without_Prices',
        errorCode: '0x099879b0',
    },
    NFTMarketScheduling_Sale_Starts_At_Already_Set: {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Already_Set',
        errorCode: '0xe5c3f263',
    },
    NFTMarketScheduling_Sale_Starts_At_Is_In_Future: {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Is_In_Future',
        errorCode: '0x4917db3f',
    },
    NFTMarketScheduling_Sale_Starts_At_Is_In_Past: {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Is_In_Past',
        errorCode: '0xdbaca9d1',
    },
    NFTMarketScheduling_Sale_Starts_At_Too_Far_In_The_Future: {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Too_Far_In_The_Future',
        errorCode: '0x857c0df1',
        params: [{ name: 'maxStartsAt', type: 'uint256' }],
    },
    NotInitializing: {
        contractName: 'NFTCollection',
        name: 'NotInitializing',
        errorCode: '0xd7e6bcf8',
    },
    Ownable_Already_Initialized: {
        contractName: 'WorldSplit',
        name: 'Ownable_Already_Initialized',
        errorCode: '0x8a279552',
        params: [{ name: 'currentOwner', type: 'address' }],
    },
    Ownable_Not_Pending_Owner: {
        contractName: 'WorldSplit',
        name: 'Ownable_Not_Pending_Owner',
        errorCode: '0xe0ad60f9',
        params: [{ name: 'currentPendingOwner', type: 'address' }],
    },
    Ownable_Sender_Is_Not_Owner: {
        contractName: 'WorldSplit',
        name: 'Ownable_Sender_Is_Not_Owner',
        errorCode: '0xc1e29402',
        params: [{ name: 'currentOwner', type: 'address' }],
    },
    Ownable_Transfer_To_Already_Initiated: {
        contractName: 'WorldSplit',
        name: 'Ownable_Transfer_To_Already_Initiated',
        errorCode: '0x12a512f6',
        params: [{ name: 'currentPendingOwner', type: 'address' }],
    },
    OwnableInvalidOwner: {
        contractName: 'NFTCollection',
        name: 'OwnableInvalidOwner',
        errorCode: '0x1e4fbdf7',
        params: [{ name: 'owner', type: 'address' }],
    },
    OwnableUnauthorizedAccount: {
        contractName: 'NFTCollection',
        name: 'OwnableUnauthorizedAccount',
        errorCode: '0x118cdaa7',
        params: [{ name: 'account', type: 'address' }],
    },
    PercentSplitETH_Each_Share_Must_Be_Less_Than_100_Percent: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Each_Share_Must_Be_Less_Than_100_Percent',
        errorCode: '0x8a4e9806',
        params: [{ name: 'shareIndex', type: 'uint256' }],
    },
    PercentSplitETH_ERC20_Split_Failed: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_ERC20_Split_Failed',
        errorCode: '0xda4c8155',
    },
    PercentSplitETH_ERC20_Tokens_Must_Be_Split: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_ERC20_Tokens_Must_Be_Split',
        errorCode: '0x36265020',
    },
    PercentSplitETH_Only_Split_Recipient_May_Call: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Only_Split_Recipient_May_Call',
        errorCode: '0x12004e16',
    },
    PercentSplitETH_Too_Few_Recipients: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Too_Few_Recipients',
        errorCode: '0xe4304b03',
        params: [{ name: 'minimumShareCount', type: 'uint256' }],
    },
    PercentSplitETH_Too_Many_Recipients: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Too_Many_Recipients',
        errorCode: '0xd94364d8',
        params: [{ name: 'maximumShareCount', type: 'uint256' }],
    },
    PercentSplitETH_Total_Shares_Must_Equal_100_Percent: {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Total_Shares_Must_Equal_100_Percent',
        errorCode: '0xcbefd922',
        params: [{ name: 'totalPercentInBasisPoints', type: 'uint256' }],
    },
    ReserveAuctionLibrary_Exceeds_Max_Duration: {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Exceeds_Max_Duration',
        errorCode: '0x5b7d3a41',
        params: [{ name: 'maxDuration', type: 'uint256' }],
    },
    ReserveAuctionLibrary_Less_Than_Extension_Duration: {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Less_Than_Extension_Duration',
        errorCode: '0x4b7f44ee',
        params: [{ name: 'extensionDuration', type: 'uint256' }],
    },
    ReserveAuctionLibrary_Must_Set_Non_Zero_Reserve_Price: {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Must_Set_Non_Zero_Reserve_Price',
        errorCode: '0x7378a92d',
    },
    ReserveAuctionLibrary_Only_Callable_By_Seller: {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Only_Callable_By_Seller',
        errorCode: '0x0907a377',
        params: [{ name: 'seller', type: 'address' }],
    },
    RevealableCollection_Already_Revealed: {
        contractName: 'NFTDropCollection',
        name: 'RevealableCollection_Already_Revealed',
        errorCode: '0xaefa400d',
    },
    RouteCallLibrary_Call_Failed_Without_Revert_Reason: {
        contractName: 'NFTMarket',
        name: 'RouteCallLibrary_Call_Failed_Without_Revert_Reason',
        errorCode: '0x3cfe059f',
    },
    RouterContextDouble_Router_Not_A_Contract: {
        contractName: 'Worlds',
        name: 'RouterContextDouble_Router_Not_A_Contract',
        errorCode: '0x9c03e172',
    },
    RouterContextSingle_Address_Is_Not_A_Contract: {
        contractName: 'NFTCollectionFactory',
        name: 'RouterContextSingle_Address_Is_Not_A_Contract',
        errorCode: '0xeddcc9ca',
    },
    SafeCastOverflowedUintDowncast: {
        contractName: 'NFTDropMarket',
        name: 'SafeCastOverflowedUintDowncast',
        errorCode: '0x6dfcc650',
        params: [
            { name: 'bits', type: 'uint8' },
            { name: 'value', type: 'uint256' },
        ],
    },
    SelfDestructibleCollection_Minted_NFTs_Must_Be_Burned_First: {
        contractName: 'NFTCollection',
        name: 'SelfDestructibleCollection_Minted_NFTs_Must_Be_Burned_First',
        errorCode: '0x707fdc25',
        params: [{ name: 'totalSupply', type: 'uint256' }],
    },
    StringsInsufficientHexLength: {
        contractName: 'FNDMiddleware',
        name: 'StringsInsufficientHexLength',
        errorCode: '0xe22e27eb',
        params: [
            { name: 'value', type: 'uint256' },
            { name: 'length', type: 'uint256' },
        ],
    },
    StringsLibrary_Required_String_Is_Empty: {
        contractName: 'NFTCollectionFactory',
        name: 'StringsLibrary_Required_String_Is_Empty',
        errorCode: '0xf73c5b53',
    },
    StringTooLong: {
        contractName: 'NFTCollection',
        name: 'StringTooLong',
        errorCode: '0x305a27a9',
        params: [{ name: 'str', type: 'string' }],
    },
    SupplyLock_Action_Disallowed_While_Supply_Is_Locked: {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Action_Disallowed_While_Supply_Is_Locked',
        errorCode: '0x2f234304',
        params: [{ name: 'supplyLockExpiration', type: 'uint256' }],
    },
    SupplyLock_Caller_Is_Not_Supply_Lock_Holder: {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Caller_Is_Not_Supply_Lock_Holder',
        errorCode: '0x5e02273e',
        params: [
            { name: 'supplyLockHolder', type: 'address' },
            { name: 'supplyLockExpiration', type: 'uint256' },
        ],
    },
    SupplyLock_Existing_Lock_Has_Already_Expired: {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Existing_Lock_Has_Already_Expired',
        errorCode: '0x18e45222',
    },
    SupplyLock_Expiration_Time_In_The_Past: {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Expiration_Time_In_The_Past',
        errorCode: '0x4bda5b0f',
    },
    SupplyLock_Expiration_Time_Too_Far_In_The_Future: {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Expiration_Time_Too_Far_In_The_Future',
        errorCode: '0x864d8247',
        params: [{ name: 'maxExpiration', type: 'uint256' }],
    },
    TimeLimitedCollection_Mint_End_Time_Must_Be_In_The_Future: {
        contractName: 'NFTTimedEditionCollection',
        name: 'TimeLimitedCollection_Mint_End_Time_Must_Be_In_The_Future',
        errorCode: '0x00a5dc45',
    },
    TimeLimitedCollection_Mint_End_Time_Too_Far_In_The_Future: {
        contractName: 'NFTTimedEditionCollection',
        name: 'TimeLimitedCollection_Mint_End_Time_Too_Far_In_The_Future',
        errorCode: '0x3bba92cc',
    },
    TimeLimitedCollection_Minting_Has_Ended: {
        contractName: 'NFTTimedEditionCollection',
        name: 'TimeLimitedCollection_Minting_Has_Ended',
        errorCode: '0x90f510f3',
        params: [{ name: 'mintEndTime', type: 'uint256' }],
    },
    TokenImmutability_Action_Disallowed: {
        contractName: 'MultiTokenCollection',
        name: 'TokenImmutability_Action_Disallowed',
        errorCode: '0x291e97c4',
    },
    TokenImmutability_Restriction_Already_Applied: {
        contractName: 'MultiTokenCollection',
        name: 'TokenImmutability_Restriction_Already_Applied',
        errorCode: '0x23dcbcd8',
    },
    TokenLimitedCollection_Max_Token_Id_May_Not_Be_Cleared: {
        contractName: 'NFTCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_May_Not_Be_Cleared',
        errorCode: '0x89a31366',
        params: [{ name: 'currentMaxTokenId', type: 'uint256' }],
    },
    TokenLimitedCollection_Max_Token_Id_May_Not_Increase: {
        contractName: 'NFTCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_May_Not_Increase',
        errorCode: '0x07f4133a',
        params: [{ name: 'currentMaxTokenId', type: 'uint256' }],
    },
    TokenLimitedCollection_Max_Token_Id_Must_Be_Greater_Than_Current_Minted_Count: {
        contractName: 'NFTCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_Must_Be_Greater_Than_Current_Minted_Count',
        errorCode: '0xbcf4db27',
        params: [{ name: 'currentMintedCount', type: 'uint256' }],
    },
    TokenLimitedCollection_Max_Token_Id_Must_Not_Be_Zero: {
        contractName: 'NFTDropCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_Must_Not_Be_Zero',
        errorCode: '0xf6858855',
    },
    TxDeadline_Tx_Deadline_Expired: {
        contractName: 'NFTDropMarket',
        name: 'TxDeadline_Tx_Deadline_Expired',
        errorCode: '0xbcb97004',
    },
    WorldsAllowlist_List_Type_Does_Not_Support_Listing_Identifier: {
        contractName: 'Worlds',
        name: 'WorldsAllowlist_List_Type_Does_Not_Support_Listing_Identifier',
        errorCode: '0xcf3d3b32',
    },
    WorldsAllowlist_Take_Rate_Above_Max: {
        contractName: 'Worlds',
        name: 'WorldsAllowlist_Take_Rate_Above_Max',
        errorCode: '0x9a5b7c1b',
        params: [{ name: 'maxTakeRate', type: 'uint256' }],
    },
    WorldsAllowlistBySeller_Address_0_May_Not_Be_Added: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Address_0_May_Not_Be_Added',
        errorCode: '0x1d7a89cf',
    },
    WorldsAllowlistBySeller_No_Sellers_Provided: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_No_Sellers_Provided',
        errorCode: '0xf12c846f',
    },
    WorldsAllowlistBySeller_Seller_Already_On_Allowlist: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Seller_Already_On_Allowlist',
        errorCode: '0xdbd1a8d9',
    },
    WorldsAllowlistBySeller_Seller_Not_Allowed: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Seller_Not_Allowed',
        errorCode: '0x090daa91',
    },
    WorldsAllowlistBySeller_Take_Rate_Too_Low: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Take_Rate_Too_Low',
        errorCode: '0x55320e00',
        params: [{ name: 'minimumTakeRateInBasisPoints', type: 'uint16' }],
    },
    WorldsAllowlistBySignature_Invalid_Approval_Type: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Invalid_Approval_Type',
        errorCode: '0xa5d981a0',
    },
    WorldsAllowlistBySignature_Signer_Is_Required: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Signer_Is_Required',
        errorCode: '0x54d169b7',
    },
    WorldsAllowlistBySignature_Tx_Deadline_Expired: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Tx_Deadline_Expired',
        errorCode: '0x58c8ca2e',
    },
    WorldsAllowlistBySignature_Tx_Deadline_Too_Far_In_Future: {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Tx_Deadline_Too_Far_In_Future',
        errorCode: '0x730a2276',
        params: [{ name: 'maxExpiration', type: 'uint256' }],
    },
    WorldsInventoryByNft_Must_Be_Collection_Owner_Or_Admin: {
        contractName: 'Worlds',
        name: 'WorldsInventoryByNft_Must_Be_Collection_Owner_Or_Admin',
        errorCode: '0xd757d78e',
    },
    WorldsInventoryByNft_Not_In_A_World: {
        contractName: 'Worlds',
        name: 'WorldsInventoryByNft_Not_In_A_World',
        errorCode: '0x693ab87c',
    },
    WorldsInventoryBySplit_Not_A_Valid_Split: {
        contractName: 'Worlds',
        name: 'WorldsInventoryBySplit_Not_A_Valid_Split',
        errorCode: '0xef05ec87',
    },
    WorldsInventoryBySplit_Not_Listed_In_A_World: {
        contractName: 'Worlds',
        name: 'WorldsInventoryBySplit_Not_Listed_In_A_World',
        errorCode: '0x895e1a5c',
    },
    WorldsInventoryBySplit_Split_Implementation_Not_A_Contract: {
        contractName: 'Worlds',
        name: 'WorldsInventoryBySplit_Split_Implementation_Not_A_Contract',
        errorCode: '0x71f1cb3d',
    },
    WorldsManagement_Already_Initialized: {
        contractName: 'Worlds',
        name: 'WorldsManagement_Already_Initialized',
        errorCode: '0xf9df0dd9',
    },
    WorldsManagement_WorldId_Exceeds_Max_Network_World_Id: {
        contractName: 'Worlds',
        name: 'WorldsManagement_WorldId_Exceeds_Max_Network_World_Id',
        errorCode: '0x0143c8d3',
        params: [{ name: 'networkMaxWorldId', type: 'uint256' }],
    },
    WorldsMetadata_Name_Already_Set: {
        contractName: 'Worlds',
        name: 'WorldsMetadata_Name_Already_Set',
        errorCode: '0x554c07c0',
    },
    WorldsMetadata_Svg_Template_Missing_WorldId_Placeholder: {
        contractName: 'Worlds',
        name: 'WorldsMetadata_Svg_Template_Missing_WorldId_Placeholder',
        errorCode: '0x8469fcdd',
    },
    WorldsNftNode_Worlds_NFT_Is_Not_A_Contract: {
        contractName: 'NFTDropMarket',
        name: 'WorldsNftNode_Worlds_NFT_Is_Not_A_Contract',
        errorCode: '0x13413123',
    },
    WorldsNotImplemented_Function_Not_Implemented: {
        contractName: 'Worlds',
        name: 'WorldsNotImplemented_Function_Not_Implemented',
        errorCode: '0xd7e493c3',
    },
    WorldsPaymentInfo_Cannot_Set_Zero_Payment_Address: {
        contractName: 'Worlds',
        name: 'WorldsPaymentInfo_Cannot_Set_Zero_Payment_Address',
        errorCode: '0x1d7b9e22',
    },
    WorldsPaymentInfo_Exceeds_Max_World_Take_Rate: {
        contractName: 'Worlds',
        name: 'WorldsPaymentInfo_Exceeds_Max_World_Take_Rate',
        errorCode: '0x9027b87e',
        params: [{ name: 'maxTakeRate', type: 'uint256' }],
    },
    WorldsPaymentInfo_Payment_Address_Already_Set: {
        contractName: 'Worlds',
        name: 'WorldsPaymentInfo_Payment_Address_Already_Set',
        errorCode: '0x2acbabd2',
    },
    WorldSplit_No_ERC1155_Balance_To_Withdraw: {
        contractName: 'WorldSplit',
        name: 'WorldSplit_No_ERC1155_Balance_To_Withdraw',
        errorCode: '0x0a42bc45',
    },
    WorldSplit_No_ERC20_Balance_To_Withdraw: {
        contractName: 'WorldSplit',
        name: 'WorldSplit_No_ERC20_Balance_To_Withdraw',
        errorCode: '0xffb6ecdb',
    },
    WorldSplit_No_ETH_Balance_To_Withdraw: {
        contractName: 'WorldSplit',
        name: 'WorldSplit_No_ETH_Balance_To_Withdraw',
        errorCode: '0xa37c7ecd',
    },
    WorldSplit_Owner_Cannot_Be_Zero_Address: {
        contractName: 'WorldSplit',
        name: 'WorldSplit_Owner_Cannot_Be_Zero_Address',
        errorCode: '0x1fa73221',
    },
    WorldsTransfer2Step_Caller_Not_Token_Owner_Or_Approved: {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Caller_Not_Token_Owner_Or_Approved',
        errorCode: '0x62272c1f',
    },
    WorldsTransfer2Step_Cannot_Transfer_To_Current_Owner: {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Cannot_Transfer_To_Current_Owner',
        errorCode: '0xfd461d23',
    },
    WorldsTransfer2Step_Not_Pending_Owner_For_Token_Id: {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Not_Pending_Owner_For_Token_Id',
        errorCode: '0x1a065e42',
        params: [{ name: 'pendingOwner', type: 'address' }],
    },
    WorldsTransfer2Step_Transfer_To_Already_Initiated: {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Transfer_To_Already_Initiated',
        errorCode: '0xdef5088a',
    },
    WorldsUserRoles_No_User_Role_Actions: {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_No_User_Role_Actions',
        errorCode: '0xd50d2390',
    },
    WorldsUserRoles_Sender_Does_Not_Have_Admin_User_Role: {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_Sender_Does_Not_Have_Admin_User_Role',
        errorCode: '0xb730a3eb',
    },
    WorldsUserRoles_Sender_Does_Not_Have_Editor_User_Role: {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_Sender_Does_Not_Have_Editor_User_Role',
        errorCode: '0x99259084',
    },
    WorldsUserRoles_Sender_Is_Not_World_Owner: {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_Sender_Is_Not_World_Owner',
        errorCode: '0x92c311b1',
    },
};
exports.ContractErrorsBySignature = {
    '0xc41405ee': {
        contractName: 'FoundationTreasury',
        name: 'AccessControl_Sender_Must_Be_Admin',
        errorCode: '0xc41405ee',
    },
    '0x6697b232': {
        contractName: 'NFTDropCollection',
        name: 'AccessControlBadConfirmation',
        errorCode: '0x6697b232',
    },
    '0xe2517d3f': {
        contractName: 'NFTDropCollection',
        name: 'AccessControlUnauthorizedAccount',
        errorCode: '0xe2517d3f',
        params: [
            { name: 'account', type: 'address' },
            { name: 'neededRole', type: 'bytes32' },
        ],
    },
    '0x9996b315': {
        contractName: 'MultiTokenCollection',
        name: 'AddressEmptyCode',
        errorCode: '0x9996b315',
        params: [{ name: 'target', type: 'address' }],
    },
    '0xcd786059': {
        contractName: 'MultiTokenCollection',
        name: 'AddressInsufficientBalance',
        errorCode: '0xcd786059',
        params: [{ name: 'account', type: 'address' }],
    },
    '0x8556197e': {
        contractName: 'NFTCollectionFactory',
        name: 'AddressLibrary_Proxy_Call_Did_Not_Return_A_Contract',
        errorCode: '0x8556197e',
        params: [{ name: 'addressReturned', type: 'address' }],
    },
    '0xf6899cee': {
        contractName: 'NFTDropCollection',
        name: 'AdminRole_Caller_Does_Not_Have_Admin_Role',
        errorCode: '0xf6899cee',
    },
    '0x25662033': {
        contractName: 'FoundationTreasury',
        name: 'AdminRoleEnumerable_Caller_Does_Not_Have_Admin_Role',
        errorCode: '0x25662033',
    },
    '0x0b335924': {
        contractName: 'FoundationTreasury',
        name: 'CollateralManagement_Cannot_Withdraw_To_Address_Zero',
        errorCode: '0x0b335924',
    },
    '0xf72e1989': {
        contractName: 'FoundationTreasury',
        name: 'CollateralManagement_Cannot_Withdraw_To_Self',
        errorCode: '0xf72e1989',
    },
    '0xcde01bec': {
        contractName: 'MultiTokenCollection',
        name: 'CollectionTokenRoyalties_Address_Already_Set',
        errorCode: '0xcde01bec',
    },
    '0xd744918b': {
        contractName: 'MultiTokenCollection',
        name: 'CollectionTokenRoyalties_Payment_Address_Required',
        errorCode: '0xd744918b',
    },
    '0xeab5a03f': {
        contractName: 'Worlds',
        name: 'DelegateForwarder_For_Internal_Use_Only',
        errorCode: '0xeab5a03f',
    },
    '0xfc52dce0': {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_General_Availability_Start_Time_Has_Expired',
        errorCode: '0xfc52dce0',
    },
    '0x0de5a71e': {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_Mint_Permission_Required',
        errorCode: '0x0de5a71e',
    },
    '0x99181b9b': {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_Only_Callable_By_Collection_Admin',
        errorCode: '0x99181b9b',
    },
    '0x77e1d3c7': {
        contractName: 'NFTDropMarket',
        name: 'DropMarketLibrary_Time_Too_Far_In_The_Future',
        errorCode: '0x77e1d3c7',
        params: [{ name: 'maxTime', type: 'uint256' }],
    },
    '0xf645eedf': {
        contractName: 'Worlds',
        name: 'ECDSAInvalidSignature',
        errorCode: '0xf645eedf',
    },
    '0xfce698f7': {
        contractName: 'Worlds',
        name: 'ECDSAInvalidSignatureLength',
        errorCode: '0xfce698f7',
        params: [{ name: 'length', type: 'uint256' }],
    },
    '0xd78bce0c': {
        contractName: 'Worlds',
        name: 'ECDSAInvalidSignatureS',
        errorCode: '0xd78bce0c',
        params: [{ name: 's', type: 'bytes32' }],
    },
    '0x3d20eda8': {
        contractName: 'Worlds',
        name: 'EIP712_Invalid_Signer',
        errorCode: '0x3d20eda8',
    },
    '0x03dee4c5': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InsufficientBalance',
        errorCode: '0x03dee4c5',
        params: [
            { name: 'sender', type: 'address' },
            { name: 'balance', type: 'uint256' },
            { name: 'needed', type: 'uint256' },
            { name: 'tokenId', type: 'uint256' },
        ],
    },
    '0x3e31884e': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidApprover',
        errorCode: '0x3e31884e',
        params: [{ name: 'approver', type: 'address' }],
    },
    '0x5b059991': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidArrayLength',
        errorCode: '0x5b059991',
        params: [
            { name: 'idsLength', type: 'uint256' },
            { name: 'valuesLength', type: 'uint256' },
        ],
    },
    '0xced3e100': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidOperator',
        errorCode: '0xced3e100',
        params: [{ name: 'operator', type: 'address' }],
    },
    '0x57f447ce': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidReceiver',
        errorCode: '0x57f447ce',
        params: [{ name: 'receiver', type: 'address' }],
    },
    '0x01a83514': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155InvalidSender',
        errorCode: '0x01a83514',
        params: [{ name: 'sender', type: 'address' }],
    },
    '0xe237d922': {
        contractName: 'MultiTokenCollection',
        name: 'ERC1155MissingApprovalForAll',
        errorCode: '0xe237d922',
        params: [
            { name: 'operator', type: 'address' },
            { name: 'owner', type: 'address' },
        ],
    },
    '0xc2f868f4': {
        contractName: 'NFTCollectionFactory',
        name: 'ERC1167FailedCreateClone',
        errorCode: '0xc2f868f4',
    },
    '0x64283d7b': {
        contractName: 'NFTCollection',
        name: 'ERC721IncorrectOwner',
        errorCode: '0x64283d7b',
        params: [
            { name: 'sender', type: 'address' },
            { name: 'tokenId', type: 'uint256' },
            { name: 'owner', type: 'address' },
        ],
    },
    '0x177e802f': {
        contractName: 'NFTCollection',
        name: 'ERC721InsufficientApproval',
        errorCode: '0x177e802f',
        params: [
            { name: 'operator', type: 'address' },
            { name: 'tokenId', type: 'uint256' },
        ],
    },
    '0xa9fbf51f': {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidApprover',
        errorCode: '0xa9fbf51f',
        params: [{ name: 'approver', type: 'address' }],
    },
    '0x5b08ba18': {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidOperator',
        errorCode: '0x5b08ba18',
        params: [{ name: 'operator', type: 'address' }],
    },
    '0x89c62b64': {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidOwner',
        errorCode: '0x89c62b64',
        params: [{ name: 'owner', type: 'address' }],
    },
    '0x64a0ae92': {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidReceiver',
        errorCode: '0x64a0ae92',
        params: [{ name: 'receiver', type: 'address' }],
    },
    '0x73c6ac6e': {
        contractName: 'NFTCollection',
        name: 'ERC721InvalidSender',
        errorCode: '0x73c6ac6e',
        params: [{ name: 'sender', type: 'address' }],
    },
    '0x7e273289': {
        contractName: 'NFTCollection',
        name: 'ERC721NonexistentToken',
        errorCode: '0x7e273289',
        params: [{ name: 'tokenId', type: 'uint256' }],
    },
    '0x74f85194': {
        contractName: 'Worlds',
        name: 'ERC721UserRoles_User_Has_No_Roles',
        errorCode: '0x74f85194',
    },
    '0xecdd1e72': {
        contractName: 'Worlds',
        name: 'ERC721UserRoles_User_Must_Not_Be_Zero_Address',
        errorCode: '0xecdd1e72',
    },
    '0xbdf15e90': {
        contractName: 'Worlds',
        name: 'ERC721UserRoles_User_Role_Already_Set',
        errorCode: '0xbdf15e90',
    },
    '0x1425ea42': {
        contractName: 'MultiTokenCollection',
        name: 'FailedInnerCall',
        errorCode: '0x1425ea42',
    },
    '0xda7f52ef': {
        contractName: 'FETH',
        name: 'FETH_Cannot_Deposit_For_Lockup_With_Address_Zero',
        errorCode: '0xda7f52ef',
    },
    '0x9681468e': {
        contractName: 'FETH',
        name: 'FETH_Cannot_Deposit_To_Address_Zero',
        errorCode: '0x9681468e',
    },
    '0xcce444a3': {
        contractName: 'FETH',
        name: 'FETH_Cannot_Deposit_To_FETH',
        errorCode: '0xcce444a3',
    },
    '0x586e5c79': {
        contractName: 'FETH',
        name: 'FETH_Cannot_Withdraw_To_Address_Zero',
        errorCode: '0x586e5c79',
    },
    '0x82b3dce9': {
        contractName: 'FETH',
        name: 'FETH_Cannot_Withdraw_To_FETH',
        errorCode: '0x82b3dce9',
    },
    '0xe296545e': {
        contractName: 'FETH',
        name: 'FETH_Cannot_Withdraw_To_Market',
        errorCode: '0xe296545e',
    },
    '0x95600b3d': {
        contractName: 'FETH',
        name: 'FETH_Escrow_Expired',
        errorCode: '0x95600b3d',
    },
    '0x2d3aa470': {
        contractName: 'FETH',
        name: 'FETH_Escrow_Not_Found',
        errorCode: '0x2d3aa470',
    },
    '0x01437d88': {
        contractName: 'FETH',
        name: 'FETH_Expiration_Too_Far_In_Future',
        errorCode: '0x01437d88',
    },
    '0xfc87283a': {
        contractName: 'FETH',
        name: 'FETH_Insufficient_Allowance',
        errorCode: '0xfc87283a',
        params: [{ name: 'amount', type: 'uint256' }],
    },
    '0xa8834ff0': {
        contractName: 'FETH',
        name: 'FETH_Insufficient_Available_Funds',
        errorCode: '0xa8834ff0',
        params: [{ name: 'amount', type: 'uint256' }],
    },
    '0x4531598a': {
        contractName: 'FETH',
        name: 'FETH_Insufficient_Escrow',
        errorCode: '0x4531598a',
        params: [{ name: 'amount', type: 'uint256' }],
    },
    '0xbe4bdada': {
        contractName: 'FETH',
        name: 'FETH_Invalid_Lockup_Duration',
        errorCode: '0xbe4bdada',
    },
    '0x1d46bfdc': {
        contractName: 'FETH',
        name: 'FETH_Market_Must_Be_A_Contract',
        errorCode: '0x1d46bfdc',
    },
    '0xd5e2ea2a': {
        contractName: 'FETH',
        name: 'FETH_Must_Deposit_Non_Zero_Amount',
        errorCode: '0xd5e2ea2a',
    },
    '0x8b7a046f': {
        contractName: 'FETH',
        name: 'FETH_Must_Lockup_Non_Zero_Amount',
        errorCode: '0x8b7a046f',
    },
    '0xb64cff25': {
        contractName: 'FETH',
        name: 'FETH_No_Funds_To_Withdraw',
        errorCode: '0xb64cff25',
    },
    '0xce3c4d0e': {
        contractName: 'FETH',
        name: 'FETH_Only_FND_Market_Allowed',
        errorCode: '0xce3c4d0e',
    },
    '0x995ace53': {
        contractName: 'FETH',
        name: 'FETH_Too_Much_ETH_Provided',
        errorCode: '0x995ace53',
    },
    '0x3450e8b1': {
        contractName: 'FETH',
        name: 'FETH_Transfer_To_Address_Zero_Not_Allowed',
        errorCode: '0x3450e8b1',
    },
    '0xb7c2c08f': {
        contractName: 'FETH',
        name: 'FETH_Transfer_To_FETH_Not_Allowed',
        errorCode: '0xb7c2c08f',
    },
    '0xde580827': {
        contractName: 'NFTDropMarket',
        name: 'FETHNode_FETH_Address_Is_Not_A_Contract',
        errorCode: '0xde580827',
    },
    '0xaa39384e': {
        contractName: 'NFTDropMarket',
        name: 'FETHNode_Only_FETH_Can_Transfer_ETH',
        errorCode: '0xaa39384e',
    },
    '0xabf2f33b': {
        contractName: 'NFTDropMarket',
        name: 'FethNode_Too_Much_Value_Provided',
        errorCode: '0xabf2f33b',
        params: [{ name: 'expectedValueAmount', type: 'uint256' }],
    },
    '0x5deff89b': {
        contractName: 'FNDMiddleware',
        name: 'FNDMiddleware_NFTs_And_TokenIds_Must_Be_The_Same_Length',
        errorCode: '0x5deff89b',
    },
    '0xa2ee8940': {
        contractName: 'NFTDropMarket',
        name: 'FoundationTreasuryNode_Address_Is_Not_A_Contract',
        errorCode: '0xa2ee8940',
    },
    '0xaf8db333': {
        contractName: 'NFTDropMarket',
        name: 'FoundationTreasuryNode_Caller_Not_Admin',
        errorCode: '0xaf8db333',
    },
    '0x795337bf': {
        contractName: 'NFTDropMarket',
        name: 'FoundationTreasuryNode_Caller_Not_Operator',
        errorCode: '0x795337bf',
    },
    '0xf92ee8a9': {
        contractName: 'NFTCollection',
        name: 'InvalidInitialization',
        errorCode: '0xf92ee8a9',
    },
    '0xb3512b0c': {
        contractName: 'NFTCollection',
        name: 'InvalidShortString',
        errorCode: '0xb3512b0c',
    },
    '0xce15a284': {
        contractName: 'NFTDropCollection',
        name: 'LazyMintedCollection_Mint_Count_Must_Be_Greater_Than_Zero',
        errorCode: '0xce15a284',
    },
    '0x8e9cd242': {
        contractName: 'MarketUtils',
        name: 'MarketUtils_Feth_Is_Not_A_Contract',
        errorCode: '0x8e9cd242',
    },
    '0xb9c39222': {
        contractName: 'MarketUtils',
        name: 'MarketUtils_Royalty_Registry_Is_Not_A_Contract',
        errorCode: '0xb9c39222',
    },
    '0x15301d40': {
        contractName: 'NFTDropCollection',
        name: 'MinterRole_Caller_Does_Not_Have_Minter_Or_Admin_Role',
        errorCode: '0x15301d40',
    },
    '0x72434cd9': {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenCollection_Contract_URI_Required',
        errorCode: '0x72434cd9',
    },
    '0x0edd7caf': {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenCollection_Token_Already_Exists',
        errorCode: '0x0edd7caf',
    },
    '0x49bedeb9': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Collection_Must_Be_ERC_1155',
        errorCode: '0x49bedeb9',
    },
    '0x928a5e07': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_General_Access_Not_Open',
        errorCode: '0x928a5e07',
        params: [{ name: 'generalAvailabilityStartTime', type: 'uint256' }],
    },
    '0xd7028da0': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
        errorCode: '0xd7028da0',
    },
    '0xfbbeeb76': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Must_Have_Available_Supply',
        errorCode: '0xfbbeeb76',
    },
    '0x0991f71f': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Payment_Address_Required',
        errorCode: '0x0991f71f',
    },
    '0x285a366d': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Recipient_Cannot_Be_Zero_Address',
        errorCode: '0x285a366d',
    },
    '0x11378a56': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Sale_Terms_Not_Found',
        errorCode: '0x11378a56',
    },
    '0xeab1694c': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Start_Time_Is_After_Mint_End_Time',
        errorCode: '0xeab1694c',
        params: [{ name: 'mintEndTime', type: 'uint256' }],
    },
    '0x7bec12a0': {
        contractName: 'MultiTokenDropMarket',
        name: 'MultiTokenDropMarketFixedPriceSale_Token_Already_Listed_For_Sale',
        errorCode: '0x7bec12a0',
        params: [{ name: 'existingSaleTermsId', type: 'uint256' }],
    },
    '0x084cdac4': {
        contractName: 'NFTMarketRouter',
        name: 'MultiTokenDropMarketFixedPriceSale_Too_Much_Value_Provided',
        errorCode: '0x084cdac4',
        params: [{ name: 'valueRemaining', type: 'uint256' }],
    },
    '0xcc2d9758': {
        contractName: 'NFTMarketRouter',
        name: 'MultiTokenDropMarketNode_Market_Is_Not_A_Contract',
        errorCode: '0xcc2d9758',
    },
    '0x6144a0ae': {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenMintSchedule_Mint_Time_Has_Already_Expired',
        errorCode: '0x6144a0ae',
    },
    '0x6b4238d8': {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenMintSchedule_Token_Minting_Has_Ended',
        errorCode: '0x6b4238d8',
    },
    '0xe56b0817': {
        contractName: 'MultiTokenCollection',
        name: 'MultiTokenMintSchedule_Token_Not_Found',
        errorCode: '0xe56b0817',
    },
    '0x797049f0': {
        contractName: 'NFTCollection',
        name: 'NFTCollection_Max_Token_Id_Has_Already_Been_Minted',
        errorCode: '0x797049f0',
        params: [{ name: 'maxTokenId', type: 'uint256' }],
    },
    '0xcd47065e': {
        contractName: 'NFTCollection',
        name: 'NFTCollection_Token_CID_Already_Minted',
        errorCode: '0xcd47065e',
    },
    '0x49860fb5': {
        contractName: 'NFTCollection',
        name: 'NFTCollection_Token_Creator_Payment_Address_Required',
        errorCode: '0x49860fb5',
    },
    '0x34a6f550': {
        contractName: 'NFTCollectionFactory',
        name: 'NFTCollectionFactoryCollectionTypes_Collection_Type_Is_Null',
        errorCode: '0x34a6f550',
    },
    '0x7fa34330': {
        contractName: 'NFTMarketRouter',
        name: 'NFTCollectionFactoryNode_Address_Is_Not_A_Contract',
        errorCode: '0x7fa34330',
    },
    '0x1c22bef2': {
        contractName: 'NFTCollectionFactory',
        name: 'NFTCollectionFactorySharedTemplates_Implementation_Not_A_Contract',
        errorCode: '0x1c22bef2',
    },
    '0xd8e61d1c': {
        contractName: 'NFTCollectionFactory',
        name: 'NFTCollectionFactorySharedTemplates_Invalid_Collection_Type',
        errorCode: '0xd8e61d1c',
    },
    '0xa87860d1': {
        contractName: 'NFTMarketRouter',
        name: 'NFTCreateAndListTimedEditionCollection_Sale_Duration_Cannot_Be_Zero',
        errorCode: '0xa87860d1',
    },
    '0xab4e7f1f': {
        contractName: 'NFTDropCollection',
        name: 'NFTDropCollection_Exceeds_Max_Token_Id',
        errorCode: '0xab4e7f1f',
        params: [{ name: 'maxTokenId', type: 'uint256' }],
    },
    '0x5ca60e0d': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarket_NFT_Already_Minted',
        errorCode: '0x5ca60e0d',
    },
    '0x25402930': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Collection_Already_Listed_For_Sale',
        errorCode: '0x25402930',
    },
    '0x229955da': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Invalid_Merkle_Root',
        errorCode: '0x229955da',
    },
    '0x3c263ade': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Must_Have_Available_Supply',
        errorCode: '0x3c263ade',
    },
    '0x17fdef07': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Must_Support_Collection_Mint_Interface',
        errorCode: '0x17fdef07',
    },
    '0x29d190d2': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketCore_Must_Support_ERC721',
        errorCode: '0x29d190d2',
    },
    '0x70fdd722': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Auction_Has_Not_Started_Yet',
        errorCode: '0x70fdd722',
        params: [{ name: 'startTime', type: 'uint256' }],
    },
    '0xcc4f974c': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Auction_Not_Found',
        errorCode: '0xcc4f974c',
    },
    '0x1dd4212a': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Clearing_Price_Not_Reached',
        errorCode: '0x1dd4212a',
        params: [
            { name: 'endTime', type: 'uint256' },
            { name: 'numberStillAvailable', type: 'uint256' },
        ],
    },
    '0xba5a58b2': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Creator_Revenue_Has_Already_Been_Withdrawn',
        errorCode: '0xba5a58b2',
    },
    '0x82fae596': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_End_Time_Too_Far_In_The_Future',
        errorCode: '0x82fae596',
        params: [{ name: 'maxTime', type: 'uint256' }],
    },
    '0xae36b525': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Invalid_Nft_Recipient',
        errorCode: '0xae36b525',
    },
    '0x92865bfe': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Limit_Per_Account_Must_Be_Set',
        errorCode: '0x92865bfe',
    },
    '0x5a42b079': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Min_Price_Must_Be_Less_Than_Max_Price',
        errorCode: '0x5a42b079',
    },
    '0xb3896a51': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Mint_Count_Must_Be_Greater_Than_Zero',
        errorCode: '0xb3896a51',
    },
    '0xb3c84a0b': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Mint_Exceeds_Limit_Per_Account',
        errorCode: '0xb3c84a0b',
        params: [
            { name: 'currentMintCount', type: 'uint256' },
            { name: 'limitPerAccount', type: 'uint256' },
        ],
    },
    '0x61b9c86b': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Must_Have_Available_Supply',
        errorCode: '0x61b9c86b',
    },
    '0x433b2e95': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Nothing_To_Rebate_At_This_Time',
        errorCode: '0x433b2e95',
    },
    '0x3335f9a9': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Sale_Duration_Must_Be_Greater_Than_Zero',
        errorCode: '0x3335f9a9',
    },
    '0x3a3baeca': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketDutchAuction_Start_Time_Must_Not_Be_In_The_Past',
        errorCode: '0x3a3baeca',
    },
    '0xfa7c028e': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Cannot_Buy_More_Than_Limit',
        errorCode: '0xfa7c028e',
        params: [{ name: 'limitPerAccount', type: 'uint256' }],
    },
    '0x8ba20e68': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Early_Access_Not_Open',
        errorCode: '0x8ba20e68',
        params: [{ name: 'earlyAccessStartTime', type: 'uint256' }],
    },
    '0xdddbb7cd': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Early_Access_Start_Time_Has_Expired',
        errorCode: '0xdddbb7cd',
    },
    '0xf2279aef': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_General_Access_Is_Open',
        errorCode: '0xf2279aef',
    },
    '0x26763e5a': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_General_Access_Not_Open',
        errorCode: '0x26763e5a',
        params: [{ name: 'generalAvailabilityStartTime', type: 'uint256' }],
    },
    '0xf88937c8': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Invalid_Merkle_Proof',
        errorCode: '0xf88937c8',
    },
    '0x250099ab': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Limit_Per_Account_Must_Be_Set',
        errorCode: '0x250099ab',
    },
    '0x974bcaec': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Must_Be_Listed_For_Sale',
        errorCode: '0x974bcaec',
    },
    '0x2d69aaf4': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
        errorCode: '0x2d69aaf4',
    },
    '0x77b2af4b': {
        contractName: 'NFTDropMarket',
        name: 'NFTDropMarketFixedPriceSale_Must_Have_Non_Zero_Early_Access_Duration',
        errorCode: '0x77b2af4b',
    },
    '0xeda2199a': {
        contractName: 'NFTMarketRouter',
        name: 'NFTDropMarketNode_Address_Is_Not_A_Contract',
        errorCode: '0xeda2199a',
    },
    '0x718fae19': {
        contractName: 'NFTLimitedEditionCollection',
        name: 'NFTLimitedEditionCollection_Exceeds_Max_Token_Id',
        errorCode: '0x718fae19',
        params: [{ name: 'maxTokenId', type: 'uint256' }],
    },
    '0xeb2e06c0': {
        contractName: 'NFTMarket',
        name: 'NFTMarketAuction_Already_Initialized',
        errorCode: '0xeb2e06c0',
    },
    '0x16b5016f': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Cannot_Buy_At_Lower_Price',
        errorCode: '0x16b5016f',
        params: [{ name: 'buyPrice', type: 'uint256' }],
    },
    '0xda48e184': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Cannot_Buy_Unset_Price',
        errorCode: '0xda48e184',
    },
    '0xc09f8e82': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Cannot_Cancel_Unset_Price',
        errorCode: '0xc09f8e82',
    },
    '0xf049b41a': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Only_Owner_Can_Cancel_Price',
        errorCode: '0xf049b41a',
        params: [{ name: 'owner', type: 'address' }],
    },
    '0x697d918e': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Only_Owner_Can_Set_Price',
        errorCode: '0x697d918e',
        params: [{ name: 'owner', type: 'address' }],
    },
    '0xc89fba3b': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Only_Owner_Can_Update_Nft',
        errorCode: '0xc89fba3b',
        params: [{ name: 'owner', type: 'address' }],
    },
    '0xb6950f36': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Price_Already_Set',
        errorCode: '0xb6950f36',
    },
    '0x35ec82cb': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Price_Too_High',
        errorCode: '0x35ec82cb',
    },
    '0x32f3b033': {
        contractName: 'NFTMarket',
        name: 'NFTMarketBuyPrice_Seller_Mismatch',
        errorCode: '0x32f3b033',
        params: [{ name: 'seller', type: 'address' }],
    },
    '0xe390a4ec': {
        contractName: 'NFTMarket',
        name: 'NFTMarketCore_Can_Not_Update_Unlisted_Nft',
        errorCode: '0xe390a4ec',
    },
    '0x57a016b3': {
        contractName: 'NFTMarket',
        name: 'NFTMarketCore_Seller_Not_Found',
        errorCode: '0x57a016b3',
    },
    '0x567777b0': {
        contractName: 'NFTDropMarket',
        name: 'NFTMarketFees_Invalid_Protocol_Fee',
        errorCode: '0x567777b0',
    },
    '0x5034dfac': {
        contractName: 'NFTDropMarket',
        name: 'NFTMarketFees_Market_Utils_Is_Not_A_Contract',
        errorCode: '0x5034dfac',
    },
    '0x48dc361f': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketNode_Address_Is_Not_A_Contract',
        errorCode: '0x48dc361f',
    },
    '0x83a483f5': {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Cannot_Be_Made_While_In_Auction',
        errorCode: '0x83a483f5',
    },
    '0x24237361': {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_Below_Min_Amount',
        errorCode: '0x24237361',
        params: [{ name: 'currentOfferAmount', type: 'uint256' }],
    },
    '0x8c9e57cf': {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_Expired',
        errorCode: '0x8c9e57cf',
        params: [{ name: 'expiry', type: 'uint256' }],
    },
    '0xa7d95dc3': {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_From_Does_Not_Match',
        errorCode: '0xa7d95dc3',
        params: [{ name: 'currentOfferFrom', type: 'address' }],
    },
    '0xe40a30e6': {
        contractName: 'NFTMarket',
        name: 'NFTMarketOffer_Offer_Must_Be_At_Least_Min_Amount',
        errorCode: '0xe40a30e6',
        params: [{ name: 'minOfferAmount', type: 'uint256' }],
    },
    '0x7618a003': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Already_Listed',
        errorCode: '0x7618a003',
        params: [{ name: 'auctionId', type: 'uint256' }],
    },
    '0xcd698a19': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Bid_Must_Be_At_Least_Min_Amount',
        errorCode: '0xcd698a19',
        params: [{ name: 'minAmount', type: 'uint256' }],
    },
    '0x31e6f71c': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Bid_Lower_Than_Reserve_Price',
        errorCode: '0x31e6f71c',
        params: [{ name: 'reservePrice', type: 'uint256' }],
    },
    '0x3feeb88d': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Bid_On_Ended_Auction',
        errorCode: '0x3feeb88d',
        params: [{ name: 'endTime', type: 'uint256' }],
    },
    '0x125197d1': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Bid_On_Nonexistent_Auction',
        errorCode: '0x125197d1',
    },
    '0x4b6ad8fa': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Finalize_Already_Settled_Auction',
        errorCode: '0x4b6ad8fa',
    },
    '0x3a017f60': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Finalize_Auction_In_Progress',
        errorCode: '0x3a017f60',
        params: [{ name: 'endTime', type: 'uint256' }],
    },
    '0xe1405768': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Rebid_Over_Outstanding_Bid',
        errorCode: '0xe1405768',
    },
    '0x5aea7c47': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Update_Auction_In_Progress',
        errorCode: '0x5aea7c47',
    },
    '0xa2a745e9': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Cannot_Update_Nft_While_Auction_In_Progress',
        errorCode: '0xa2a745e9',
    },
    '0xe64526ee': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Not_Matching_Seller',
        errorCode: '0xe64526ee',
        params: [{ name: 'seller', type: 'address' }],
    },
    '0x4b669ac7': {
        contractName: 'NFTMarket',
        name: 'NFTMarketReserveAuction_Price_Already_Set',
        errorCode: '0x4b669ac7',
    },
    '0x1a8a2c10': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Buy_Price_Set_But_Should_Set_Buy_Price_Is_False',
        errorCode: '0x1a8a2c10',
    },
    '0xbf2c1df0': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Duration_Set_Without_Reserve_Price',
        errorCode: '0xbf2c1df0',
    },
    '0xbee0394e': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Missing_World_Associations',
        errorCode: '0xbee0394e',
    },
    '0x3c574a98': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Must_Set_Reserve_Buy_Price_Or_World',
        errorCode: '0x3c574a98',
    },
    '0x75ce98b6': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Must_Set_Reserve_Or_Buy_Price',
        errorCode: '0x75ce98b6',
    },
    '0x69a1d316': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Schedule_Set_Without_Prices',
        errorCode: '0x69a1d316',
    },
    '0xa9d004a5': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_Token_Ids_Not_Set',
        errorCode: '0xa9d004a5',
    },
    '0x099879b0': {
        contractName: 'NFTMarketRouter',
        name: 'NFTMarketRouterList_World_Id_Set_Without_Prices',
        errorCode: '0x099879b0',
    },
    '0xe5c3f263': {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Already_Set',
        errorCode: '0xe5c3f263',
    },
    '0x4917db3f': {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Is_In_Future',
        errorCode: '0x4917db3f',
    },
    '0xdbaca9d1': {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Is_In_Past',
        errorCode: '0xdbaca9d1',
    },
    '0x857c0df1': {
        contractName: 'NFTMarket',
        name: 'NFTMarketScheduling_Sale_Starts_At_Too_Far_In_The_Future',
        errorCode: '0x857c0df1',
        params: [{ name: 'maxStartsAt', type: 'uint256' }],
    },
    '0xd7e6bcf8': {
        contractName: 'NFTCollection',
        name: 'NotInitializing',
        errorCode: '0xd7e6bcf8',
    },
    '0x8a279552': {
        contractName: 'WorldSplit',
        name: 'Ownable_Already_Initialized',
        errorCode: '0x8a279552',
        params: [{ name: 'currentOwner', type: 'address' }],
    },
    '0xe0ad60f9': {
        contractName: 'WorldSplit',
        name: 'Ownable_Not_Pending_Owner',
        errorCode: '0xe0ad60f9',
        params: [{ name: 'currentPendingOwner', type: 'address' }],
    },
    '0xc1e29402': {
        contractName: 'WorldSplit',
        name: 'Ownable_Sender_Is_Not_Owner',
        errorCode: '0xc1e29402',
        params: [{ name: 'currentOwner', type: 'address' }],
    },
    '0x12a512f6': {
        contractName: 'WorldSplit',
        name: 'Ownable_Transfer_To_Already_Initiated',
        errorCode: '0x12a512f6',
        params: [{ name: 'currentPendingOwner', type: 'address' }],
    },
    '0x1e4fbdf7': {
        contractName: 'NFTCollection',
        name: 'OwnableInvalidOwner',
        errorCode: '0x1e4fbdf7',
        params: [{ name: 'owner', type: 'address' }],
    },
    '0x118cdaa7': {
        contractName: 'NFTCollection',
        name: 'OwnableUnauthorizedAccount',
        errorCode: '0x118cdaa7',
        params: [{ name: 'account', type: 'address' }],
    },
    '0x8a4e9806': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Each_Share_Must_Be_Less_Than_100_Percent',
        errorCode: '0x8a4e9806',
        params: [{ name: 'shareIndex', type: 'uint256' }],
    },
    '0xda4c8155': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_ERC20_Split_Failed',
        errorCode: '0xda4c8155',
    },
    '0x36265020': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_ERC20_Tokens_Must_Be_Split',
        errorCode: '0x36265020',
    },
    '0x12004e16': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Only_Split_Recipient_May_Call',
        errorCode: '0x12004e16',
    },
    '0xe4304b03': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Too_Few_Recipients',
        errorCode: '0xe4304b03',
        params: [{ name: 'minimumShareCount', type: 'uint256' }],
    },
    '0xd94364d8': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Too_Many_Recipients',
        errorCode: '0xd94364d8',
        params: [{ name: 'maximumShareCount', type: 'uint256' }],
    },
    '0xcbefd922': {
        contractName: 'PercentSplitETH',
        name: 'PercentSplitETH_Total_Shares_Must_Equal_100_Percent',
        errorCode: '0xcbefd922',
        params: [{ name: 'totalPercentInBasisPoints', type: 'uint256' }],
    },
    '0x5b7d3a41': {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Exceeds_Max_Duration',
        errorCode: '0x5b7d3a41',
        params: [{ name: 'maxDuration', type: 'uint256' }],
    },
    '0x4b7f44ee': {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Less_Than_Extension_Duration',
        errorCode: '0x4b7f44ee',
        params: [{ name: 'extensionDuration', type: 'uint256' }],
    },
    '0x7378a92d': {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Must_Set_Non_Zero_Reserve_Price',
        errorCode: '0x7378a92d',
    },
    '0x0907a377': {
        contractName: 'NFTMarket',
        name: 'ReserveAuctionLibrary_Only_Callable_By_Seller',
        errorCode: '0x0907a377',
        params: [{ name: 'seller', type: 'address' }],
    },
    '0xaefa400d': {
        contractName: 'NFTDropCollection',
        name: 'RevealableCollection_Already_Revealed',
        errorCode: '0xaefa400d',
    },
    '0x3cfe059f': {
        contractName: 'NFTMarket',
        name: 'RouteCallLibrary_Call_Failed_Without_Revert_Reason',
        errorCode: '0x3cfe059f',
    },
    '0x9c03e172': {
        contractName: 'Worlds',
        name: 'RouterContextDouble_Router_Not_A_Contract',
        errorCode: '0x9c03e172',
    },
    '0xeddcc9ca': {
        contractName: 'NFTCollectionFactory',
        name: 'RouterContextSingle_Address_Is_Not_A_Contract',
        errorCode: '0xeddcc9ca',
    },
    '0x6dfcc650': {
        contractName: 'NFTDropMarket',
        name: 'SafeCastOverflowedUintDowncast',
        errorCode: '0x6dfcc650',
        params: [
            { name: 'bits', type: 'uint8' },
            { name: 'value', type: 'uint256' },
        ],
    },
    '0x707fdc25': {
        contractName: 'NFTCollection',
        name: 'SelfDestructibleCollection_Minted_NFTs_Must_Be_Burned_First',
        errorCode: '0x707fdc25',
        params: [{ name: 'totalSupply', type: 'uint256' }],
    },
    '0xe22e27eb': {
        contractName: 'FNDMiddleware',
        name: 'StringsInsufficientHexLength',
        errorCode: '0xe22e27eb',
        params: [
            { name: 'value', type: 'uint256' },
            { name: 'length', type: 'uint256' },
        ],
    },
    '0xf73c5b53': {
        contractName: 'NFTCollectionFactory',
        name: 'StringsLibrary_Required_String_Is_Empty',
        errorCode: '0xf73c5b53',
    },
    '0x305a27a9': {
        contractName: 'NFTCollection',
        name: 'StringTooLong',
        errorCode: '0x305a27a9',
        params: [{ name: 'str', type: 'string' }],
    },
    '0x2f234304': {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Action_Disallowed_While_Supply_Is_Locked',
        errorCode: '0x2f234304',
        params: [{ name: 'supplyLockExpiration', type: 'uint256' }],
    },
    '0x5e02273e': {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Caller_Is_Not_Supply_Lock_Holder',
        errorCode: '0x5e02273e',
        params: [
            { name: 'supplyLockHolder', type: 'address' },
            { name: 'supplyLockExpiration', type: 'uint256' },
        ],
    },
    '0x18e45222': {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Existing_Lock_Has_Already_Expired',
        errorCode: '0x18e45222',
    },
    '0x4bda5b0f': {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Expiration_Time_In_The_Past',
        errorCode: '0x4bda5b0f',
    },
    '0x864d8247': {
        contractName: 'NFTDropCollection',
        name: 'SupplyLock_Expiration_Time_Too_Far_In_The_Future',
        errorCode: '0x864d8247',
        params: [{ name: 'maxExpiration', type: 'uint256' }],
    },
    '0x00a5dc45': {
        contractName: 'NFTTimedEditionCollection',
        name: 'TimeLimitedCollection_Mint_End_Time_Must_Be_In_The_Future',
        errorCode: '0x00a5dc45',
    },
    '0x3bba92cc': {
        contractName: 'NFTTimedEditionCollection',
        name: 'TimeLimitedCollection_Mint_End_Time_Too_Far_In_The_Future',
        errorCode: '0x3bba92cc',
    },
    '0x90f510f3': {
        contractName: 'NFTTimedEditionCollection',
        name: 'TimeLimitedCollection_Minting_Has_Ended',
        errorCode: '0x90f510f3',
        params: [{ name: 'mintEndTime', type: 'uint256' }],
    },
    '0x291e97c4': {
        contractName: 'MultiTokenCollection',
        name: 'TokenImmutability_Action_Disallowed',
        errorCode: '0x291e97c4',
    },
    '0x23dcbcd8': {
        contractName: 'MultiTokenCollection',
        name: 'TokenImmutability_Restriction_Already_Applied',
        errorCode: '0x23dcbcd8',
    },
    '0x89a31366': {
        contractName: 'NFTCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_May_Not_Be_Cleared',
        errorCode: '0x89a31366',
        params: [{ name: 'currentMaxTokenId', type: 'uint256' }],
    },
    '0x07f4133a': {
        contractName: 'NFTCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_May_Not_Increase',
        errorCode: '0x07f4133a',
        params: [{ name: 'currentMaxTokenId', type: 'uint256' }],
    },
    '0xbcf4db27': {
        contractName: 'NFTCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_Must_Be_Greater_Than_Current_Minted_Count',
        errorCode: '0xbcf4db27',
        params: [{ name: 'currentMintedCount', type: 'uint256' }],
    },
    '0xf6858855': {
        contractName: 'NFTDropCollection',
        name: 'TokenLimitedCollection_Max_Token_Id_Must_Not_Be_Zero',
        errorCode: '0xf6858855',
    },
    '0xbcb97004': {
        contractName: 'NFTDropMarket',
        name: 'TxDeadline_Tx_Deadline_Expired',
        errorCode: '0xbcb97004',
    },
    '0xcf3d3b32': {
        contractName: 'Worlds',
        name: 'WorldsAllowlist_List_Type_Does_Not_Support_Listing_Identifier',
        errorCode: '0xcf3d3b32',
    },
    '0x9a5b7c1b': {
        contractName: 'Worlds',
        name: 'WorldsAllowlist_Take_Rate_Above_Max',
        errorCode: '0x9a5b7c1b',
        params: [{ name: 'maxTakeRate', type: 'uint256' }],
    },
    '0x1d7a89cf': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Address_0_May_Not_Be_Added',
        errorCode: '0x1d7a89cf',
    },
    '0xf12c846f': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_No_Sellers_Provided',
        errorCode: '0xf12c846f',
    },
    '0xdbd1a8d9': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Seller_Already_On_Allowlist',
        errorCode: '0xdbd1a8d9',
    },
    '0x090daa91': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Seller_Not_Allowed',
        errorCode: '0x090daa91',
    },
    '0x55320e00': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySeller_Take_Rate_Too_Low',
        errorCode: '0x55320e00',
        params: [{ name: 'minimumTakeRateInBasisPoints', type: 'uint16' }],
    },
    '0xa5d981a0': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Invalid_Approval_Type',
        errorCode: '0xa5d981a0',
    },
    '0x54d169b7': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Signer_Is_Required',
        errorCode: '0x54d169b7',
    },
    '0x58c8ca2e': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Tx_Deadline_Expired',
        errorCode: '0x58c8ca2e',
    },
    '0x730a2276': {
        contractName: 'Worlds',
        name: 'WorldsAllowlistBySignature_Tx_Deadline_Too_Far_In_Future',
        errorCode: '0x730a2276',
        params: [{ name: 'maxExpiration', type: 'uint256' }],
    },
    '0xd757d78e': {
        contractName: 'Worlds',
        name: 'WorldsInventoryByNft_Must_Be_Collection_Owner_Or_Admin',
        errorCode: '0xd757d78e',
    },
    '0x693ab87c': {
        contractName: 'Worlds',
        name: 'WorldsInventoryByNft_Not_In_A_World',
        errorCode: '0x693ab87c',
    },
    '0xef05ec87': {
        contractName: 'Worlds',
        name: 'WorldsInventoryBySplit_Not_A_Valid_Split',
        errorCode: '0xef05ec87',
    },
    '0x895e1a5c': {
        contractName: 'Worlds',
        name: 'WorldsInventoryBySplit_Not_Listed_In_A_World',
        errorCode: '0x895e1a5c',
    },
    '0x71f1cb3d': {
        contractName: 'Worlds',
        name: 'WorldsInventoryBySplit_Split_Implementation_Not_A_Contract',
        errorCode: '0x71f1cb3d',
    },
    '0xf9df0dd9': {
        contractName: 'Worlds',
        name: 'WorldsManagement_Already_Initialized',
        errorCode: '0xf9df0dd9',
    },
    '0x0143c8d3': {
        contractName: 'Worlds',
        name: 'WorldsManagement_WorldId_Exceeds_Max_Network_World_Id',
        errorCode: '0x0143c8d3',
        params: [{ name: 'networkMaxWorldId', type: 'uint256' }],
    },
    '0x554c07c0': {
        contractName: 'Worlds',
        name: 'WorldsMetadata_Name_Already_Set',
        errorCode: '0x554c07c0',
    },
    '0x8469fcdd': {
        contractName: 'Worlds',
        name: 'WorldsMetadata_Svg_Template_Missing_WorldId_Placeholder',
        errorCode: '0x8469fcdd',
    },
    '0x13413123': {
        contractName: 'NFTDropMarket',
        name: 'WorldsNftNode_Worlds_NFT_Is_Not_A_Contract',
        errorCode: '0x13413123',
    },
    '0xd7e493c3': {
        contractName: 'Worlds',
        name: 'WorldsNotImplemented_Function_Not_Implemented',
        errorCode: '0xd7e493c3',
    },
    '0x1d7b9e22': {
        contractName: 'Worlds',
        name: 'WorldsPaymentInfo_Cannot_Set_Zero_Payment_Address',
        errorCode: '0x1d7b9e22',
    },
    '0x9027b87e': {
        contractName: 'Worlds',
        name: 'WorldsPaymentInfo_Exceeds_Max_World_Take_Rate',
        errorCode: '0x9027b87e',
        params: [{ name: 'maxTakeRate', type: 'uint256' }],
    },
    '0x2acbabd2': {
        contractName: 'Worlds',
        name: 'WorldsPaymentInfo_Payment_Address_Already_Set',
        errorCode: '0x2acbabd2',
    },
    '0x0a42bc45': {
        contractName: 'WorldSplit',
        name: 'WorldSplit_No_ERC1155_Balance_To_Withdraw',
        errorCode: '0x0a42bc45',
    },
    '0xffb6ecdb': {
        contractName: 'WorldSplit',
        name: 'WorldSplit_No_ERC20_Balance_To_Withdraw',
        errorCode: '0xffb6ecdb',
    },
    '0xa37c7ecd': {
        contractName: 'WorldSplit',
        name: 'WorldSplit_No_ETH_Balance_To_Withdraw',
        errorCode: '0xa37c7ecd',
    },
    '0x1fa73221': {
        contractName: 'WorldSplit',
        name: 'WorldSplit_Owner_Cannot_Be_Zero_Address',
        errorCode: '0x1fa73221',
    },
    '0x62272c1f': {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Caller_Not_Token_Owner_Or_Approved',
        errorCode: '0x62272c1f',
    },
    '0xfd461d23': {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Cannot_Transfer_To_Current_Owner',
        errorCode: '0xfd461d23',
    },
    '0x1a065e42': {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Not_Pending_Owner_For_Token_Id',
        errorCode: '0x1a065e42',
        params: [{ name: 'pendingOwner', type: 'address' }],
    },
    '0xdef5088a': {
        contractName: 'Worlds',
        name: 'WorldsTransfer2Step_Transfer_To_Already_Initiated',
        errorCode: '0xdef5088a',
    },
    '0xd50d2390': {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_No_User_Role_Actions',
        errorCode: '0xd50d2390',
    },
    '0xb730a3eb': {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_Sender_Does_Not_Have_Admin_User_Role',
        errorCode: '0xb730a3eb',
    },
    '0x99259084': {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_Sender_Does_Not_Have_Editor_User_Role',
        errorCode: '0x99259084',
    },
    '0x92c311b1': {
        contractName: 'Worlds',
        name: 'WorldsUserRoles_Sender_Is_Not_World_Owner',
        errorCode: '0x92c311b1',
    },
};
exports.ContractErrorNames = [
    'AccessControl_Sender_Must_Be_Admin',
    'AccessControlBadConfirmation',
    'AccessControlUnauthorizedAccount',
    'AddressEmptyCode',
    'AddressInsufficientBalance',
    'AddressLibrary_Proxy_Call_Did_Not_Return_A_Contract',
    'AdminRole_Caller_Does_Not_Have_Admin_Role',
    'AdminRoleEnumerable_Caller_Does_Not_Have_Admin_Role',
    'CollateralManagement_Cannot_Withdraw_To_Address_Zero',
    'CollateralManagement_Cannot_Withdraw_To_Self',
    'CollectionTokenRoyalties_Address_Already_Set',
    'CollectionTokenRoyalties_Payment_Address_Required',
    'DelegateForwarder_For_Internal_Use_Only',
    'DropMarketLibrary_General_Availability_Start_Time_Has_Expired',
    'DropMarketLibrary_Mint_Permission_Required',
    'DropMarketLibrary_Only_Callable_By_Collection_Admin',
    'DropMarketLibrary_Time_Too_Far_In_The_Future',
    'ECDSAInvalidSignature',
    'ECDSAInvalidSignatureLength',
    'ECDSAInvalidSignatureS',
    'EIP712_Invalid_Signer',
    'ERC1155InsufficientBalance',
    'ERC1155InvalidApprover',
    'ERC1155InvalidArrayLength',
    'ERC1155InvalidOperator',
    'ERC1155InvalidReceiver',
    'ERC1155InvalidSender',
    'ERC1155MissingApprovalForAll',
    'ERC1167FailedCreateClone',
    'ERC721IncorrectOwner',
    'ERC721InsufficientApproval',
    'ERC721InvalidApprover',
    'ERC721InvalidOperator',
    'ERC721InvalidOwner',
    'ERC721InvalidReceiver',
    'ERC721InvalidSender',
    'ERC721NonexistentToken',
    'ERC721UserRoles_User_Has_No_Roles',
    'ERC721UserRoles_User_Must_Not_Be_Zero_Address',
    'ERC721UserRoles_User_Role_Already_Set',
    'FailedInnerCall',
    'FETH_Cannot_Deposit_For_Lockup_With_Address_Zero',
    'FETH_Cannot_Deposit_To_Address_Zero',
    'FETH_Cannot_Deposit_To_FETH',
    'FETH_Cannot_Withdraw_To_Address_Zero',
    'FETH_Cannot_Withdraw_To_FETH',
    'FETH_Cannot_Withdraw_To_Market',
    'FETH_Escrow_Expired',
    'FETH_Escrow_Not_Found',
    'FETH_Expiration_Too_Far_In_Future',
    'FETH_Insufficient_Allowance',
    'FETH_Insufficient_Available_Funds',
    'FETH_Insufficient_Escrow',
    'FETH_Invalid_Lockup_Duration',
    'FETH_Market_Must_Be_A_Contract',
    'FETH_Must_Deposit_Non_Zero_Amount',
    'FETH_Must_Lockup_Non_Zero_Amount',
    'FETH_No_Funds_To_Withdraw',
    'FETH_Only_FND_Market_Allowed',
    'FETH_Too_Much_ETH_Provided',
    'FETH_Transfer_To_Address_Zero_Not_Allowed',
    'FETH_Transfer_To_FETH_Not_Allowed',
    'FETHNode_FETH_Address_Is_Not_A_Contract',
    'FETHNode_Only_FETH_Can_Transfer_ETH',
    'FethNode_Too_Much_Value_Provided',
    'FNDMiddleware_NFTs_And_TokenIds_Must_Be_The_Same_Length',
    'FoundationTreasuryNode_Address_Is_Not_A_Contract',
    'FoundationTreasuryNode_Caller_Not_Admin',
    'FoundationTreasuryNode_Caller_Not_Operator',
    'InvalidInitialization',
    'InvalidShortString',
    'LazyMintedCollection_Mint_Count_Must_Be_Greater_Than_Zero',
    'MarketUtils_Feth_Is_Not_A_Contract',
    'MarketUtils_Royalty_Registry_Is_Not_A_Contract',
    'MinterRole_Caller_Does_Not_Have_Minter_Or_Admin_Role',
    'MultiTokenCollection_Contract_URI_Required',
    'MultiTokenCollection_Token_Already_Exists',
    'MultiTokenDropMarketFixedPriceSale_Collection_Must_Be_ERC_1155',
    'MultiTokenDropMarketFixedPriceSale_General_Access_Not_Open',
    'MultiTokenDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
    'MultiTokenDropMarketFixedPriceSale_Must_Have_Available_Supply',
    'MultiTokenDropMarketFixedPriceSale_Payment_Address_Required',
    'MultiTokenDropMarketFixedPriceSale_Recipient_Cannot_Be_Zero_Address',
    'MultiTokenDropMarketFixedPriceSale_Sale_Terms_Not_Found',
    'MultiTokenDropMarketFixedPriceSale_Start_Time_Is_After_Mint_End_Time',
    'MultiTokenDropMarketFixedPriceSale_Token_Already_Listed_For_Sale',
    'MultiTokenDropMarketFixedPriceSale_Too_Much_Value_Provided',
    'MultiTokenDropMarketNode_Market_Is_Not_A_Contract',
    'MultiTokenMintSchedule_Mint_Time_Has_Already_Expired',
    'MultiTokenMintSchedule_Token_Minting_Has_Ended',
    'MultiTokenMintSchedule_Token_Not_Found',
    'NFTCollection_Max_Token_Id_Has_Already_Been_Minted',
    'NFTCollection_Token_CID_Already_Minted',
    'NFTCollection_Token_Creator_Payment_Address_Required',
    'NFTCollectionFactoryCollectionTypes_Collection_Type_Is_Null',
    'NFTCollectionFactoryNode_Address_Is_Not_A_Contract',
    'NFTCollectionFactorySharedTemplates_Implementation_Not_A_Contract',
    'NFTCollectionFactorySharedTemplates_Invalid_Collection_Type',
    'NFTCreateAndListTimedEditionCollection_Sale_Duration_Cannot_Be_Zero',
    'NFTDropCollection_Exceeds_Max_Token_Id',
    'NFTDropMarket_NFT_Already_Minted',
    'NFTDropMarketCore_Collection_Already_Listed_For_Sale',
    'NFTDropMarketCore_Invalid_Merkle_Root',
    'NFTDropMarketCore_Must_Have_Available_Supply',
    'NFTDropMarketCore_Must_Support_Collection_Mint_Interface',
    'NFTDropMarketCore_Must_Support_ERC721',
    'NFTDropMarketDutchAuction_Auction_Has_Not_Started_Yet',
    'NFTDropMarketDutchAuction_Auction_Not_Found',
    'NFTDropMarketDutchAuction_Clearing_Price_Not_Reached',
    'NFTDropMarketDutchAuction_Creator_Revenue_Has_Already_Been_Withdrawn',
    'NFTDropMarketDutchAuction_End_Time_Too_Far_In_The_Future',
    'NFTDropMarketDutchAuction_Invalid_Nft_Recipient',
    'NFTDropMarketDutchAuction_Limit_Per_Account_Must_Be_Set',
    'NFTDropMarketDutchAuction_Min_Price_Must_Be_Less_Than_Max_Price',
    'NFTDropMarketDutchAuction_Mint_Count_Must_Be_Greater_Than_Zero',
    'NFTDropMarketDutchAuction_Mint_Exceeds_Limit_Per_Account',
    'NFTDropMarketDutchAuction_Must_Have_Available_Supply',
    'NFTDropMarketDutchAuction_Nothing_To_Rebate_At_This_Time',
    'NFTDropMarketDutchAuction_Sale_Duration_Must_Be_Greater_Than_Zero',
    'NFTDropMarketDutchAuction_Start_Time_Must_Not_Be_In_The_Past',
    'NFTDropMarketFixedPriceSale_Cannot_Buy_More_Than_Limit',
    'NFTDropMarketFixedPriceSale_Early_Access_Not_Open',
    'NFTDropMarketFixedPriceSale_Early_Access_Start_Time_Has_Expired',
    'NFTDropMarketFixedPriceSale_General_Access_Is_Open',
    'NFTDropMarketFixedPriceSale_General_Access_Not_Open',
    'NFTDropMarketFixedPriceSale_Invalid_Merkle_Proof',
    'NFTDropMarketFixedPriceSale_Limit_Per_Account_Must_Be_Set',
    'NFTDropMarketFixedPriceSale_Must_Be_Listed_For_Sale',
    'NFTDropMarketFixedPriceSale_Must_Buy_At_Least_One_Token',
    'NFTDropMarketFixedPriceSale_Must_Have_Non_Zero_Early_Access_Duration',
    'NFTDropMarketNode_Address_Is_Not_A_Contract',
    'NFTLimitedEditionCollection_Exceeds_Max_Token_Id',
    'NFTMarketAuction_Already_Initialized',
    'NFTMarketBuyPrice_Cannot_Buy_At_Lower_Price',
    'NFTMarketBuyPrice_Cannot_Buy_Unset_Price',
    'NFTMarketBuyPrice_Cannot_Cancel_Unset_Price',
    'NFTMarketBuyPrice_Only_Owner_Can_Cancel_Price',
    'NFTMarketBuyPrice_Only_Owner_Can_Set_Price',
    'NFTMarketBuyPrice_Only_Owner_Can_Update_Nft',
    'NFTMarketBuyPrice_Price_Already_Set',
    'NFTMarketBuyPrice_Price_Too_High',
    'NFTMarketBuyPrice_Seller_Mismatch',
    'NFTMarketCore_Can_Not_Update_Unlisted_Nft',
    'NFTMarketCore_Seller_Not_Found',
    'NFTMarketFees_Invalid_Protocol_Fee',
    'NFTMarketFees_Market_Utils_Is_Not_A_Contract',
    'NFTMarketNode_Address_Is_Not_A_Contract',
    'NFTMarketOffer_Cannot_Be_Made_While_In_Auction',
    'NFTMarketOffer_Offer_Below_Min_Amount',
    'NFTMarketOffer_Offer_Expired',
    'NFTMarketOffer_Offer_From_Does_Not_Match',
    'NFTMarketOffer_Offer_Must_Be_At_Least_Min_Amount',
    'NFTMarketReserveAuction_Already_Listed',
    'NFTMarketReserveAuction_Bid_Must_Be_At_Least_Min_Amount',
    'NFTMarketReserveAuction_Cannot_Bid_Lower_Than_Reserve_Price',
    'NFTMarketReserveAuction_Cannot_Bid_On_Ended_Auction',
    'NFTMarketReserveAuction_Cannot_Bid_On_Nonexistent_Auction',
    'NFTMarketReserveAuction_Cannot_Finalize_Already_Settled_Auction',
    'NFTMarketReserveAuction_Cannot_Finalize_Auction_In_Progress',
    'NFTMarketReserveAuction_Cannot_Rebid_Over_Outstanding_Bid',
    'NFTMarketReserveAuction_Cannot_Update_Auction_In_Progress',
    'NFTMarketReserveAuction_Cannot_Update_Nft_While_Auction_In_Progress',
    'NFTMarketReserveAuction_Not_Matching_Seller',
    'NFTMarketReserveAuction_Price_Already_Set',
    'NFTMarketRouterList_Buy_Price_Set_But_Should_Set_Buy_Price_Is_False',
    'NFTMarketRouterList_Duration_Set_Without_Reserve_Price',
    'NFTMarketRouterList_Missing_World_Associations',
    'NFTMarketRouterList_Must_Set_Reserve_Buy_Price_Or_World',
    'NFTMarketRouterList_Must_Set_Reserve_Or_Buy_Price',
    'NFTMarketRouterList_Schedule_Set_Without_Prices',
    'NFTMarketRouterList_Token_Ids_Not_Set',
    'NFTMarketRouterList_World_Id_Set_Without_Prices',
    'NFTMarketScheduling_Sale_Starts_At_Already_Set',
    'NFTMarketScheduling_Sale_Starts_At_Is_In_Future',
    'NFTMarketScheduling_Sale_Starts_At_Is_In_Past',
    'NFTMarketScheduling_Sale_Starts_At_Too_Far_In_The_Future',
    'NotInitializing',
    'Ownable_Already_Initialized',
    'Ownable_Not_Pending_Owner',
    'Ownable_Sender_Is_Not_Owner',
    'Ownable_Transfer_To_Already_Initiated',
    'OwnableInvalidOwner',
    'OwnableUnauthorizedAccount',
    'PercentSplitETH_Each_Share_Must_Be_Less_Than_100_Percent',
    'PercentSplitETH_ERC20_Split_Failed',
    'PercentSplitETH_ERC20_Tokens_Must_Be_Split',
    'PercentSplitETH_Only_Split_Recipient_May_Call',
    'PercentSplitETH_Too_Few_Recipients',
    'PercentSplitETH_Too_Many_Recipients',
    'PercentSplitETH_Total_Shares_Must_Equal_100_Percent',
    'ReserveAuctionLibrary_Exceeds_Max_Duration',
    'ReserveAuctionLibrary_Less_Than_Extension_Duration',
    'ReserveAuctionLibrary_Must_Set_Non_Zero_Reserve_Price',
    'ReserveAuctionLibrary_Only_Callable_By_Seller',
    'RevealableCollection_Already_Revealed',
    'RouteCallLibrary_Call_Failed_Without_Revert_Reason',
    'RouterContextDouble_Router_Not_A_Contract',
    'RouterContextSingle_Address_Is_Not_A_Contract',
    'SafeCastOverflowedUintDowncast',
    'SelfDestructibleCollection_Minted_NFTs_Must_Be_Burned_First',
    'StringsInsufficientHexLength',
    'StringsLibrary_Required_String_Is_Empty',
    'StringTooLong',
    'SupplyLock_Action_Disallowed_While_Supply_Is_Locked',
    'SupplyLock_Caller_Is_Not_Supply_Lock_Holder',
    'SupplyLock_Existing_Lock_Has_Already_Expired',
    'SupplyLock_Expiration_Time_In_The_Past',
    'SupplyLock_Expiration_Time_Too_Far_In_The_Future',
    'TimeLimitedCollection_Mint_End_Time_Must_Be_In_The_Future',
    'TimeLimitedCollection_Mint_End_Time_Too_Far_In_The_Future',
    'TimeLimitedCollection_Minting_Has_Ended',
    'TokenImmutability_Action_Disallowed',
    'TokenImmutability_Restriction_Already_Applied',
    'TokenLimitedCollection_Max_Token_Id_May_Not_Be_Cleared',
    'TokenLimitedCollection_Max_Token_Id_May_Not_Increase',
    'TokenLimitedCollection_Max_Token_Id_Must_Be_Greater_Than_Current_Minted_Count',
    'TokenLimitedCollection_Max_Token_Id_Must_Not_Be_Zero',
    'TxDeadline_Tx_Deadline_Expired',
    'WorldsAllowlist_List_Type_Does_Not_Support_Listing_Identifier',
    'WorldsAllowlist_Take_Rate_Above_Max',
    'WorldsAllowlistBySeller_Address_0_May_Not_Be_Added',
    'WorldsAllowlistBySeller_No_Sellers_Provided',
    'WorldsAllowlistBySeller_Seller_Already_On_Allowlist',
    'WorldsAllowlistBySeller_Seller_Not_Allowed',
    'WorldsAllowlistBySeller_Take_Rate_Too_Low',
    'WorldsAllowlistBySignature_Invalid_Approval_Type',
    'WorldsAllowlistBySignature_Signer_Is_Required',
    'WorldsAllowlistBySignature_Tx_Deadline_Expired',
    'WorldsAllowlistBySignature_Tx_Deadline_Too_Far_In_Future',
    'WorldsInventoryByNft_Must_Be_Collection_Owner_Or_Admin',
    'WorldsInventoryByNft_Not_In_A_World',
    'WorldsInventoryBySplit_Not_A_Valid_Split',
    'WorldsInventoryBySplit_Not_Listed_In_A_World',
    'WorldsInventoryBySplit_Split_Implementation_Not_A_Contract',
    'WorldsManagement_Already_Initialized',
    'WorldsManagement_WorldId_Exceeds_Max_Network_World_Id',
    'WorldsMetadata_Name_Already_Set',
    'WorldsMetadata_Svg_Template_Missing_WorldId_Placeholder',
    'WorldsNftNode_Worlds_NFT_Is_Not_A_Contract',
    'WorldsNotImplemented_Function_Not_Implemented',
    'WorldsPaymentInfo_Cannot_Set_Zero_Payment_Address',
    'WorldsPaymentInfo_Exceeds_Max_World_Take_Rate',
    'WorldsPaymentInfo_Payment_Address_Already_Set',
    'WorldSplit_No_ERC1155_Balance_To_Withdraw',
    'WorldSplit_No_ERC20_Balance_To_Withdraw',
    'WorldSplit_No_ETH_Balance_To_Withdraw',
    'WorldSplit_Owner_Cannot_Be_Zero_Address',
    'WorldsTransfer2Step_Caller_Not_Token_Owner_Or_Approved',
    'WorldsTransfer2Step_Cannot_Transfer_To_Current_Owner',
    'WorldsTransfer2Step_Not_Pending_Owner_For_Token_Id',
    'WorldsTransfer2Step_Transfer_To_Already_Initiated',
    'WorldsUserRoles_No_User_Role_Actions',
    'WorldsUserRoles_Sender_Does_Not_Have_Admin_User_Role',
    'WorldsUserRoles_Sender_Does_Not_Have_Editor_User_Role',
    'WorldsUserRoles_Sender_Is_Not_World_Owner',
];
exports.ContractErrorSignatures = [
    '0xc41405ee',
    '0x6697b232',
    '0xe2517d3f',
    '0x9996b315',
    '0xcd786059',
    '0x8556197e',
    '0xf6899cee',
    '0x25662033',
    '0x0b335924',
    '0xf72e1989',
    '0xcde01bec',
    '0xd744918b',
    '0xeab5a03f',
    '0xfc52dce0',
    '0x0de5a71e',
    '0x99181b9b',
    '0x77e1d3c7',
    '0xf645eedf',
    '0xfce698f7',
    '0xd78bce0c',
    '0x3d20eda8',
    '0x03dee4c5',
    '0x3e31884e',
    '0x5b059991',
    '0xced3e100',
    '0x57f447ce',
    '0x01a83514',
    '0xe237d922',
    '0xc2f868f4',
    '0x64283d7b',
    '0x177e802f',
    '0xa9fbf51f',
    '0x5b08ba18',
    '0x89c62b64',
    '0x64a0ae92',
    '0x73c6ac6e',
    '0x7e273289',
    '0x74f85194',
    '0xecdd1e72',
    '0xbdf15e90',
    '0x1425ea42',
    '0xda7f52ef',
    '0x9681468e',
    '0xcce444a3',
    '0x586e5c79',
    '0x82b3dce9',
    '0xe296545e',
    '0x95600b3d',
    '0x2d3aa470',
    '0x01437d88',
    '0xfc87283a',
    '0xa8834ff0',
    '0x4531598a',
    '0xbe4bdada',
    '0x1d46bfdc',
    '0xd5e2ea2a',
    '0x8b7a046f',
    '0xb64cff25',
    '0xce3c4d0e',
    '0x995ace53',
    '0x3450e8b1',
    '0xb7c2c08f',
    '0xde580827',
    '0xaa39384e',
    '0xabf2f33b',
    '0x5deff89b',
    '0xa2ee8940',
    '0xaf8db333',
    '0x795337bf',
    '0xf92ee8a9',
    '0xb3512b0c',
    '0xce15a284',
    '0x8e9cd242',
    '0xb9c39222',
    '0x15301d40',
    '0x72434cd9',
    '0x0edd7caf',
    '0x49bedeb9',
    '0x928a5e07',
    '0xd7028da0',
    '0xfbbeeb76',
    '0x0991f71f',
    '0x285a366d',
    '0x11378a56',
    '0xeab1694c',
    '0x7bec12a0',
    '0x084cdac4',
    '0xcc2d9758',
    '0x6144a0ae',
    '0x6b4238d8',
    '0xe56b0817',
    '0x797049f0',
    '0xcd47065e',
    '0x49860fb5',
    '0x34a6f550',
    '0x7fa34330',
    '0x1c22bef2',
    '0xd8e61d1c',
    '0xa87860d1',
    '0xab4e7f1f',
    '0x5ca60e0d',
    '0x25402930',
    '0x229955da',
    '0x3c263ade',
    '0x17fdef07',
    '0x29d190d2',
    '0x70fdd722',
    '0xcc4f974c',
    '0x1dd4212a',
    '0xba5a58b2',
    '0x82fae596',
    '0xae36b525',
    '0x92865bfe',
    '0x5a42b079',
    '0xb3896a51',
    '0xb3c84a0b',
    '0x61b9c86b',
    '0x433b2e95',
    '0x3335f9a9',
    '0x3a3baeca',
    '0xfa7c028e',
    '0x8ba20e68',
    '0xdddbb7cd',
    '0xf2279aef',
    '0x26763e5a',
    '0xf88937c8',
    '0x250099ab',
    '0x974bcaec',
    '0x2d69aaf4',
    '0x77b2af4b',
    '0xeda2199a',
    '0x718fae19',
    '0xeb2e06c0',
    '0x16b5016f',
    '0xda48e184',
    '0xc09f8e82',
    '0xf049b41a',
    '0x697d918e',
    '0xc89fba3b',
    '0xb6950f36',
    '0x35ec82cb',
    '0x32f3b033',
    '0xe390a4ec',
    '0x57a016b3',
    '0x567777b0',
    '0x5034dfac',
    '0x48dc361f',
    '0x83a483f5',
    '0x24237361',
    '0x8c9e57cf',
    '0xa7d95dc3',
    '0xe40a30e6',
    '0x7618a003',
    '0xcd698a19',
    '0x31e6f71c',
    '0x3feeb88d',
    '0x125197d1',
    '0x4b6ad8fa',
    '0x3a017f60',
    '0xe1405768',
    '0x5aea7c47',
    '0xa2a745e9',
    '0xe64526ee',
    '0x4b669ac7',
    '0x1a8a2c10',
    '0xbf2c1df0',
    '0xbee0394e',
    '0x3c574a98',
    '0x75ce98b6',
    '0x69a1d316',
    '0xa9d004a5',
    '0x099879b0',
    '0xe5c3f263',
    '0x4917db3f',
    '0xdbaca9d1',
    '0x857c0df1',
    '0xd7e6bcf8',
    '0x8a279552',
    '0xe0ad60f9',
    '0xc1e29402',
    '0x12a512f6',
    '0x1e4fbdf7',
    '0x118cdaa7',
    '0x8a4e9806',
    '0xda4c8155',
    '0x36265020',
    '0x12004e16',
    '0xe4304b03',
    '0xd94364d8',
    '0xcbefd922',
    '0x5b7d3a41',
    '0x4b7f44ee',
    '0x7378a92d',
    '0x0907a377',
    '0xaefa400d',
    '0x3cfe059f',
    '0x9c03e172',
    '0xeddcc9ca',
    '0x6dfcc650',
    '0x707fdc25',
    '0xe22e27eb',
    '0xf73c5b53',
    '0x305a27a9',
    '0x2f234304',
    '0x5e02273e',
    '0x18e45222',
    '0x4bda5b0f',
    '0x864d8247',
    '0x00a5dc45',
    '0x3bba92cc',
    '0x90f510f3',
    '0x291e97c4',
    '0x23dcbcd8',
    '0x89a31366',
    '0x07f4133a',
    '0xbcf4db27',
    '0xf6858855',
    '0xbcb97004',
    '0xcf3d3b32',
    '0x9a5b7c1b',
    '0x1d7a89cf',
    '0xf12c846f',
    '0xdbd1a8d9',
    '0x090daa91',
    '0x55320e00',
    '0xa5d981a0',
    '0x54d169b7',
    '0x58c8ca2e',
    '0x730a2276',
    '0xd757d78e',
    '0x693ab87c',
    '0xef05ec87',
    '0x895e1a5c',
    '0x71f1cb3d',
    '0xf9df0dd9',
    '0x0143c8d3',
    '0x554c07c0',
    '0x8469fcdd',
    '0x13413123',
    '0xd7e493c3',
    '0x1d7b9e22',
    '0x9027b87e',
    '0x2acbabd2',
    '0x0a42bc45',
    '0xffb6ecdb',
    '0xa37c7ecd',
    '0x1fa73221',
    '0x62272c1f',
    '0xfd461d23',
    '0x1a065e42',
    '0xdef5088a',
    '0xd50d2390',
    '0xb730a3eb',
    '0x99259084',
    '0x92c311b1',
];
//# sourceMappingURL=errors.generated.js.map